module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 113);
}({
  0: function _(e, t) {
    e.exports = require("react");
  },
  1: function _(e, t, n) {
    e.exports = n(20)();
  },
  101: function _(e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r),
        i = n(74),
        a = n(75),
        s = n(18),
        u = n(1),
        c = n.n(u),
        l = n(97),
        f = n.n(l);

    function d(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var p = function p(e) {
      var t,
          n = d(Object(r.useState)(), 2),
          u = n[0],
          c = n[1];
      return Object(r.useEffect)(function () {
        e.canvasRef && e.canvasRef.current && c(new f.a(e.canvasRef.current));
      }, [e.canvasRef]), u && e.playlist.forEach(function (e) {
        var t = e.type,
            n = e.sourceStart,
            r = e.start,
            o = e.duration,
            i = e.src,
            a = u[t](i, n);
        a.startAt(r), a.stopAt(r + o), a.connect(u.destination);
      }), o.a.createElement(o.a.Fragment, null, o.a.createElement(s.a, {
        className: "justify-content-center",
        style: {
          backgroundColor: "black"
        }
      }, o.a.createElement("canvas", {
        ref: e.canvasRef,
        width: e.width,
        height: .5625 * e.width
      })), o.a.createElement(s.a, {
        className: "justify-content-center",
        style: {
          backgroundColor: "lightgrey"
        }
      }, o.a.createElement(i.default, {
        videoContext: u
      })), o.a.createElement(s.a, {
        style: {
          marginTop: "0.4em"
        }
      }, o.a.createElement(a.default, {
        handlePlay: u ? function () {
          return u.play();
        } : function () {
          return console.log("handlePlay");
        },
        handlePause: u ? function () {
          return u.pause();
        } : function () {
          return console.log("handlePause");
        },
        handleStop: u ? function () {
          return u.pause(), void c(function (e) {
            return e.currentTime = 0, e;
          });
        } : function () {
          return console.log("handleStop");
        }
      })), o.a.createElement(s.a, {
        className: "justify-content-center"
      }, "Total duration: ", u ? (t = u.duration, new Date(1e3 * t).toISOString().substr(11, 8)) : "00:00:00"));
    };

    p.propTypes = {
      canvasRef: c.a.any,
      playlist: c.a.array,
      videoContext: c.a.any,
      width: c.a.any
    }, p.defaultProps = {
      playlist: []
    }, t.default = p;
  },
  113: function _(e, t, n) {
    "use strict";

    n.r(t);

    var r = n(0),
        o = n.n(r),
        i = n(101),
        a = n(1),
        s = n.n(a),
        u = function u(e) {
      var t = Object(r.useRef)();
      return o.a.createElement(i.default, {
        width: e.width,
        canvasRef: t,
        playlist: e.playlist
      });
    };

    u.propTypes = {
      playlist: s.a.array,
      width: s.a.number
    }, u.defaultProps = {
      playlist: []
    }, t.default = u;
  },
  13: function _(e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  },
  14: function _(e, t, n) {
    "use strict";

    (function (e, r) {
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function i(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      function a(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function s(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), r.forEach(function (t) {
            a(e, t, n[t]);
          });
        }

        return e;
      }

      function u(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }

      n.d(t, "a", function () {
        return je;
      }), n.d(t, "b", function () {
        return De;
      });

      var c = function c() {},
          l = {},
          f = {},
          d = {
        mark: c,
        measure: c
      };

      try {
        "undefined" != typeof window && (l = window), "undefined" != typeof document && (f = document), "undefined" != typeof MutationObserver && MutationObserver, "undefined" != typeof performance && (d = performance);
      } catch (e) {}

      var p = (l.navigator || {}).userAgent,
          v = void 0 === p ? "" : p,
          _ = l,
          h = f,
          m = d,
          y = (_.document, !!h.documentElement && !!h.head && "function" == typeof h.addEventListener && "function" == typeof h.createElement),
          g = (~v.indexOf("MSIE") || v.indexOf("Trident/"), "fa"),
          b = "svg-inline--fa",
          x = "data-fa-i2svg",
          T = (function () {
        try {} catch (e) {
          return !1;
        }
      }(), [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
          E = T.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
          C = {
        GROUP: "group",
        SWAP_OPACITY: "swap-opacity",
        PRIMARY: "primary",
        SECONDARY: "secondary"
      },
          O = (["xs", "sm", "lg", "fw", "ul", "li", "border", "pull-left", "pull-right", "spin", "pulse", "rotate-90", "rotate-180", "rotate-270", "flip-horizontal", "flip-vertical", "flip-both", "stack", "stack-1x", "stack-2x", "inverse", "layers", "layers-text", "layers-counter", C.GROUP, C.SWAP_OPACITY, C.PRIMARY, C.SECONDARY].concat(T.map(function (e) {
        return "".concat(e, "x");
      })).concat(E.map(function (e) {
        return "w-".concat(e);
      })), _.FontAwesomeConfig || {});

      if (h && "function" == typeof h.querySelector) {
        [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (e) {
          var t = u(e, 2),
              n = t[0],
              r = t[1],
              o = function (e) {
            return "" === e || "false" !== e && ("true" === e || e);
          }(function (e) {
            var t = h.querySelector("script[" + e + "]");
            if (t) return t.getAttribute(e);
          }(n));

          null != o && (O[r] = o);
        });
      }

      var w = s({}, {
        familyPrefix: g,
        replacementClass: b,
        autoReplaceSvg: !0,
        autoAddCss: !0,
        autoA11y: !0,
        searchPseudoElements: !1,
        observeMutations: !0,
        mutateApproach: "async",
        keepOriginalSource: !0,
        measurePerformance: !1,
        showMissingIcons: !0
      }, O);
      w.autoReplaceSvg || (w.observeMutations = !1);
      var S = s({}, w);
      _.FontAwesomeConfig = S;
      var A = _ || {};
      A.___FONT_AWESOME___ || (A.___FONT_AWESOME___ = {}), A.___FONT_AWESOME___.styles || (A.___FONT_AWESOME___.styles = {}), A.___FONT_AWESOME___.hooks || (A.___FONT_AWESOME___.hooks = {}), A.___FONT_AWESOME___.shims || (A.___FONT_AWESOME___.shims = []);
      var k = A.___FONT_AWESOME___,
          P = [];
      y && ((h.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(h.readyState) || h.addEventListener("DOMContentLoaded", function e() {
        h.removeEventListener("DOMContentLoaded", e), 1, P.map(function (e) {
          return e();
        });
      }));

      var N,
          D = "pending",
          j = "settled",
          R = "fulfilled",
          F = "rejected",
          M = function M() {},
          I = void 0 !== e && void 0 !== e.process && "function" == typeof e.process.emit,
          U = void 0 === r ? setTimeout : r,
          L = [];

      function z() {
        for (var e = 0; e < L.length; e++) {
          L[e][0](L[e][1]);
        }

        L = [], N = !1;
      }

      function W(e, t) {
        L.push([e, t]), N || (N = !0, U(z, 0));
      }

      function B(e) {
        var t = e.owner,
            n = t._state,
            r = t._data,
            o = e[n],
            i = e.then;

        if ("function" == typeof o) {
          n = R;

          try {
            r = o(r);
          } catch (e) {
            X(i, e);
          }
        }

        V(i, r) || (n === R && G(i, r), n === F && X(i, r));
      }

      function V(e, t) {
        var n;

        try {
          if (e === t) throw new TypeError("A promises callback cannot return that same promise.");

          if (t && ("function" == typeof t || "object" === o(t))) {
            var r = t.then;
            if ("function" == typeof r) return r.call(t, function (r) {
              n || (n = !0, t === r ? Y(e, r) : G(e, r));
            }, function (t) {
              n || (n = !0, X(e, t));
            }), !0;
          }
        } catch (t) {
          return n || X(e, t), !0;
        }

        return !1;
      }

      function G(e, t) {
        e !== t && V(e, t) || Y(e, t);
      }

      function Y(e, t) {
        e._state === D && (e._state = j, e._data = t, W(q, e));
      }

      function X(e, t) {
        e._state === D && (e._state = j, e._data = t, W(K, e));
      }

      function H(e) {
        e._then = e._then.forEach(B);
      }

      function q(e) {
        e._state = R, H(e);
      }

      function K(t) {
        t._state = F, H(t), !t._handled && I && e.process.emit("unhandledRejection", t._data, t);
      }

      function Z(t) {
        e.process.emit("rejectionHandled", t);
      }

      function J(e) {
        if ("function" != typeof e) throw new TypeError("Promise resolver " + e + " is not a function");
        if (this instanceof J == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        this._then = [], function (e, t) {
          function n(e) {
            X(t, e);
          }

          try {
            e(function (e) {
              G(t, e);
            }, n);
          } catch (e) {
            n(e);
          }
        }(e, this);
      }

      J.prototype = {
        constructor: J,
        _state: D,
        _then: null,
        _data: void 0,
        _handled: !1,
        then: function then(e, t) {
          var n = {
            owner: this,
            then: new this.constructor(M),
            fulfilled: e,
            rejected: t
          };
          return !t && !e || this._handled || (this._handled = !0, this._state === F && I && W(Z, this)), this._state === R || this._state === F ? W(B, n) : this._then.push(n), n.then;
        },
        catch: function _catch(e) {
          return this.then(null, e);
        }
      }, J.all = function (e) {
        if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.all().");
        return new J(function (t, n) {
          var r = [],
              o = 0;

          function i(e) {
            return o++, function (n) {
              r[e] = n, --o || t(r);
            };
          }

          for (var a, s = 0; s < e.length; s++) {
            (a = e[s]) && "function" == typeof a.then ? a.then(i(s), n) : r[s] = a;
          }

          o || t(r);
        });
      }, J.race = function (e) {
        if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.race().");
        return new J(function (t, n) {
          for (var r, o = 0; o < e.length; o++) {
            (r = e[o]) && "function" == typeof r.then ? r.then(t, n) : t(r);
          }
        });
      }, J.resolve = function (e) {
        return e && "object" === o(e) && e.constructor === J ? e : new J(function (t) {
          t(e);
        });
      }, J.reject = function (e) {
        return new J(function (t, n) {
          n(e);
        });
      };
      "function" == typeof Promise && Promise;
      var $ = {
        size: 16,
        x: 0,
        y: 0,
        rotate: 0,
        flipX: !1,
        flipY: !1
      };

      function Q(e) {
        if (e && y) {
          var t = h.createElement("style");
          t.setAttribute("type", "text/css"), t.innerHTML = e;

          for (var n = h.head.childNodes, r = null, o = n.length - 1; o > -1; o--) {
            var i = n[o],
                a = (i.tagName || "").toUpperCase();
            ["STYLE", "LINK"].indexOf(a) > -1 && (r = i);
          }

          return h.head.insertBefore(t, r), e;
        }
      }

      var ee = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

      function te() {
        for (var e = 12, t = ""; e-- > 0;) {
          t += ee[62 * Math.random() | 0];
        }

        return t;
      }

      function ne(e) {
        return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      }

      function re(e) {
        return Object.keys(e || {}).reduce(function (t, n) {
          return t + "".concat(n, ": ").concat(e[n], ";");
        }, "");
      }

      function oe(e) {
        return e.size !== $.size || e.x !== $.x || e.y !== $.y || e.rotate !== $.rotate || e.flipX || e.flipY;
      }

      function ie(e) {
        var t = e.transform,
            n = e.containerWidth,
            r = e.iconWidth,
            o = {
          transform: "translate(".concat(n / 2, " 256)")
        },
            i = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
            a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
            s = "rotate(".concat(t.rotate, " 0 0)");
        return {
          outer: o,
          inner: {
            transform: "".concat(i, " ").concat(a, " ").concat(s)
          },
          path: {
            transform: "translate(".concat(r / 2 * -1, " -256)")
          }
        };
      }

      var ae = {
        x: 0,
        y: 0,
        width: "100%",
        height: "100%"
      };

      function se(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
      }

      function ue(e) {
        var t = e.icons,
            n = t.main,
            r = t.mask,
            o = e.prefix,
            i = e.iconName,
            a = e.transform,
            u = e.symbol,
            c = e.title,
            l = e.extra,
            f = e.watchable,
            d = void 0 !== f && f,
            p = r.found ? r : n,
            v = p.width,
            _ = p.height,
            h = "fa-w-".concat(Math.ceil(v / _ * 16)),
            m = [S.replacementClass, i ? "".concat(S.familyPrefix, "-").concat(i) : "", h].filter(function (e) {
          return -1 === l.classes.indexOf(e);
        }).concat(l.classes).join(" "),
            y = {
          children: [],
          attributes: s({}, l.attributes, {
            "data-prefix": o,
            "data-icon": i,
            class: m,
            role: l.attributes.role || "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 ".concat(v, " ").concat(_)
          })
        };
        d && (y.attributes[x] = ""), c && y.children.push({
          tag: "title",
          attributes: {
            id: y.attributes["aria-labelledby"] || "title-".concat(te())
          },
          children: [c]
        });
        var g = s({}, y, {
          prefix: o,
          iconName: i,
          main: n,
          mask: r,
          transform: a,
          symbol: u,
          styles: l.styles
        }),
            b = r.found && n.found ? function (e) {
          var t,
              n = e.children,
              r = e.attributes,
              o = e.main,
              i = e.mask,
              a = e.transform,
              u = o.width,
              c = o.icon,
              l = i.width,
              f = i.icon,
              d = ie({
            transform: a,
            containerWidth: l,
            iconWidth: u
          }),
              p = {
            tag: "rect",
            attributes: s({}, ae, {
              fill: "white"
            })
          },
              v = c.children ? {
            children: c.children.map(se)
          } : {},
              _ = {
            tag: "g",
            attributes: s({}, d.inner),
            children: [se(s({
              tag: c.tag,
              attributes: s({}, c.attributes, d.path)
            }, v))]
          },
              h = {
            tag: "g",
            attributes: s({}, d.outer),
            children: [_]
          },
              m = "mask-".concat(te()),
              y = "clip-".concat(te()),
              g = {
            tag: "mask",
            attributes: s({}, ae, {
              id: m,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse"
            }),
            children: [p, h]
          },
              b = {
            tag: "defs",
            children: [{
              tag: "clipPath",
              attributes: {
                id: y
              },
              children: (t = f, "g" === t.tag ? t.children : [t])
            }, g]
          };
          return n.push(b, {
            tag: "rect",
            attributes: s({
              fill: "currentColor",
              "clip-path": "url(#".concat(y, ")"),
              mask: "url(#".concat(m, ")")
            }, ae)
          }), {
            children: n,
            attributes: r
          };
        }(g) : function (e) {
          var t = e.children,
              n = e.attributes,
              r = e.main,
              o = e.transform,
              i = re(e.styles);

          if (i.length > 0 && (n.style = i), oe(o)) {
            var a = ie({
              transform: o,
              containerWidth: r.width,
              iconWidth: r.width
            });
            t.push({
              tag: "g",
              attributes: s({}, a.outer),
              children: [{
                tag: "g",
                attributes: s({}, a.inner),
                children: [{
                  tag: r.icon.tag,
                  children: r.icon.children,
                  attributes: s({}, r.icon.attributes, a.path)
                }]
              }]
            });
          } else t.push(r.icon);

          return {
            children: t,
            attributes: n
          };
        }(g),
            T = b.children,
            E = b.attributes;
        return g.children = T, g.attributes = E, u ? function (e) {
          var t = e.prefix,
              n = e.iconName,
              r = e.children,
              o = e.attributes,
              i = e.symbol;
          return [{
            tag: "svg",
            attributes: {
              style: "display: none;"
            },
            children: [{
              tag: "symbol",
              attributes: s({}, o, {
                id: !0 === i ? "".concat(t, "-").concat(S.familyPrefix, "-").concat(n) : i
              }),
              children: r
            }]
          }];
        }(g) : function (e) {
          var t = e.children,
              n = e.main,
              r = e.mask,
              o = e.attributes,
              i = e.styles,
              a = e.transform;

          if (oe(a) && n.found && !r.found) {
            var u = {
              x: n.width / n.height / 2,
              y: .5
            };
            o.style = re(s({}, i, {
              "transform-origin": "".concat(u.x + a.x / 16, "em ").concat(u.y + a.y / 16, "em")
            }));
          }

          return [{
            tag: "svg",
            attributes: o,
            children: t
          }];
        }(g);
      }

      var ce = function ce() {},
          le = (S.measurePerformance && m && m.mark && m.measure, function (e, t, n, r) {
        var o,
            i,
            a,
            s = Object.keys(e),
            u = s.length,
            c = void 0 !== r ? function (e, t) {
          return function (n, r, o, i) {
            return e.call(t, n, r, o, i);
          };
        }(t, r) : t;

        for (void 0 === n ? (o = 1, a = e[s[0]]) : (o = 0, a = n); o < u; o++) {
          a = c(a, e[i = s[o]], i, e);
        }

        return a;
      });

      function fe(e, t) {
        var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).skipHooks,
            r = void 0 !== n && n,
            o = Object.keys(t).reduce(function (e, n) {
          var r = t[n];
          return !!r.icon ? e[r.iconName] = r.icon : e[n] = r, e;
        }, {});
        "function" != typeof k.hooks.addPack || r ? k.styles[e] = s({}, k.styles[e] || {}, o) : k.hooks.addPack(e, o), "fas" === e && fe("fa", t);
      }

      var de = k.styles,
          pe = k.shims,
          ve = function ve() {
        var e = function e(_e2) {
          return le(de, function (t, n, r) {
            return t[r] = le(n, _e2, {}), t;
          }, {});
        };

        e(function (e, t, n) {
          return t[3] && (e[t[3]] = n), e;
        }), e(function (e, t, n) {
          var r = t[2];
          return e[n] = n, r.forEach(function (t) {
            e[t] = n;
          }), e;
        });
        var t = "far" in de;
        le(pe, function (e, n) {
          var r = n[0],
              o = n[1],
              i = n[2];
          return "far" !== o || t || (o = "fas"), e[r] = {
            prefix: o,
            iconName: i
          }, e;
        }, {});
      };

      ve();
      k.styles;

      function _e(e, t, n) {
        if (e && e[t] && e[t][n]) return {
          prefix: t,
          iconName: n,
          icon: e[t][n]
        };
      }

      function he(e) {
        var t = e.tag,
            n = e.attributes,
            r = void 0 === n ? {} : n,
            o = e.children,
            i = void 0 === o ? [] : o;
        return "string" == typeof e ? ne(e) : "<".concat(t, " ").concat(function (e) {
          return Object.keys(e || {}).reduce(function (t, n) {
            return t + "".concat(n, '="').concat(ne(e[n]), '" ');
          }, "").trim();
        }(r), ">").concat(i.map(he).join(""), "</").concat(t, ">");
      }

      var me = function me(e) {
        var t = {
          size: 16,
          x: 0,
          y: 0,
          flipX: !1,
          flipY: !1,
          rotate: 0
        };
        return e ? e.toLowerCase().split(" ").reduce(function (e, t) {
          var n = t.toLowerCase().split("-"),
              r = n[0],
              o = n.slice(1).join("-");
          if (r && "h" === o) return e.flipX = !0, e;
          if (r && "v" === o) return e.flipY = !0, e;
          if (o = parseFloat(o), isNaN(o)) return e;

          switch (r) {
            case "grow":
              e.size = e.size + o;
              break;

            case "shrink":
              e.size = e.size - o;
              break;

            case "left":
              e.x = e.x - o;
              break;

            case "right":
              e.x = e.x + o;
              break;

            case "up":
              e.y = e.y - o;
              break;

            case "down":
              e.y = e.y + o;
              break;

            case "rotate":
              e.rotate = e.rotate + o;
          }

          return e;
        }, t) : t;
      };

      function ye(e) {
        this.name = "MissingIcon", this.message = e || "Icon unavailable", this.stack = new Error().stack;
      }

      ye.prototype = Object.create(Error.prototype), ye.prototype.constructor = ye;
      var ge = {
        fill: "currentColor"
      },
          be = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      },
          xe = {
        tag: "path",
        attributes: s({}, ge, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      },
          Te = s({}, be, {
        attributeName: "opacity"
      });
      s({}, ge, {
        cx: "256",
        cy: "364",
        r: "28"
      }), s({}, be, {
        attributeName: "r",
        values: "28;14;28;28;14;28;"
      }), s({}, Te, {
        values: "1;0;1;1;0;1;"
      }), s({}, ge, {
        opacity: "1",
        d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
      }), s({}, Te, {
        values: "1;0;0;0;0;1;"
      }), s({}, ge, {
        opacity: "0",
        d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
      }), s({}, Te, {
        values: "0;0;1;1;0;0;"
      }), k.styles;

      function Ee(e) {
        var t = e[0],
            n = e[1],
            r = u(e.slice(4), 1)[0];
        return {
          found: !0,
          width: t,
          height: n,
          icon: Array.isArray(r) ? {
            tag: "g",
            attributes: {
              class: "".concat(S.familyPrefix, "-").concat(C.GROUP)
            },
            children: [{
              tag: "path",
              attributes: {
                class: "".concat(S.familyPrefix, "-").concat(C.SECONDARY),
                fill: "currentColor",
                d: r[0]
              }
            }, {
              tag: "path",
              attributes: {
                class: "".concat(S.familyPrefix, "-").concat(C.PRIMARY),
                fill: "currentColor",
                d: r[1]
              }
            }]
          } : {
            tag: "path",
            attributes: {
              fill: "currentColor",
              d: r
            }
          }
        };
      }

      k.styles;
      var Ce = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';

      function Oe() {
        var e = g,
            t = b,
            n = S.familyPrefix,
            r = S.replacementClass,
            o = Ce;

        if (n !== e || r !== t) {
          var i = new RegExp("\\.".concat(e, "\\-"), "g"),
              a = new RegExp("\\--".concat(e, "\\-"), "g"),
              s = new RegExp("\\.".concat(t), "g");
          o = o.replace(i, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
        }

        return o;
      }

      function we() {
        S.autoAddCss && !Ne && (Q(Oe()), Ne = !0);
      }

      function Se(e, t) {
        return Object.defineProperty(e, "abstract", {
          get: t
        }), Object.defineProperty(e, "html", {
          get: function get() {
            return e.abstract.map(function (e) {
              return he(e);
            });
          }
        }), Object.defineProperty(e, "node", {
          get: function get() {
            if (y) {
              var t = h.createElement("div");
              return t.innerHTML = e.html, t.children;
            }
          }
        }), e;
      }

      function Ae(e) {
        var t = e.prefix,
            n = void 0 === t ? "fa" : t,
            r = e.iconName;
        if (r) return _e(Pe.definitions, n, r) || _e(k.styles, n, r);
      }

      var ke,
          Pe = new (function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.definitions = {};
        }

        var t, n, r;
        return t = e, (n = [{
          key: "add",
          value: function value() {
            for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
              n[r] = arguments[r];
            }

            var o = n.reduce(this._pullDefinitions, {});
            Object.keys(o).forEach(function (t) {
              e.definitions[t] = s({}, e.definitions[t] || {}, o[t]), fe(t, o[t]), ve();
            });
          }
        }, {
          key: "reset",
          value: function value() {
            this.definitions = {};
          }
        }, {
          key: "_pullDefinitions",
          value: function value(e, t) {
            var n = t.prefix && t.iconName && t.icon ? {
              0: t
            } : t;
            return Object.keys(n).map(function (t) {
              var r = n[t],
                  o = r.prefix,
                  i = r.iconName,
                  a = r.icon;
              e[o] || (e[o] = {}), e[o][i] = a;
            }), e;
          }
        }]) && i(t.prototype, n), r && i(t, r), e;
      }())(),
          Ne = !1,
          De = {
        transform: function transform(e) {
          return me(e);
        }
      },
          je = (ke = function ke(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.transform,
            r = void 0 === n ? $ : n,
            o = t.symbol,
            i = void 0 !== o && o,
            a = t.mask,
            u = void 0 === a ? null : a,
            c = t.title,
            l = void 0 === c ? null : c,
            f = t.classes,
            d = void 0 === f ? [] : f,
            p = t.attributes,
            v = void 0 === p ? {} : p,
            _ = t.styles,
            h = void 0 === _ ? {} : _;

        if (e) {
          var m = e.prefix,
              y = e.iconName,
              g = e.icon;
          return Se(s({
            type: "icon"
          }, e), function () {
            return we(), S.autoA11y && (l ? v["aria-labelledby"] = "".concat(S.replacementClass, "-title-").concat(te()) : (v["aria-hidden"] = "true", v.focusable = "false")), ue({
              icons: {
                main: Ee(g),
                mask: u ? Ee(u.icon) : {
                  found: !1,
                  width: null,
                  height: null,
                  icon: {}
                }
              },
              prefix: m,
              iconName: y,
              transform: s({}, $, r),
              symbol: i,
              title: l,
              extra: {
                attributes: v,
                styles: h,
                classes: d
              }
            });
          });
        }
      }, function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = (e || {}).icon ? e : Ae(e || {}),
            r = t.mask;
        return r && (r = (r || {}).icon ? r : Ae(r || {})), ke(n, s({}, t, {
          mask: r
        }));
      });
    }).call(this, n(13), n(30).setImmediate);
  },
  15: function _(e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e, t) {
      var n = void 0 === t ? {} : t,
          r = n.propTypes,
          i = n.defaultProps,
          a = n.allowFallback,
          s = void 0 !== a && a,
          u = n.displayName,
          c = void 0 === u ? e.name || e.displayName : u,
          l = function l(t, n) {
        return e(t, n);
      };

      return Object.assign(o.default.forwardRef || !s ? o.default.forwardRef(l) : function (e) {
        return l(e, null);
      }, {
        displayName: c,
        propTypes: r,
        defaultProps: i
      });
    };
    var r,
        o = (r = n(0)) && r.__esModule ? r : {
      default: r
    };
  },
  18: function _(e, t, n) {
    "use strict";

    var r = n(2),
        o = n(3),
        i = n(4),
        a = n.n(i),
        s = n(0),
        u = n.n(s),
        c = n(5),
        l = u.a.forwardRef(function (e, t) {
      var n = e.bsPrefix,
          i = e.noGutters,
          s = e.as,
          l = void 0 === s ? "div" : s,
          f = e.className,
          d = Object(o.a)(e, ["bsPrefix", "noGutters", "as", "className"]),
          p = Object(c.b)(n, "row");
      return u.a.createElement(l, Object(r.a)({
        ref: t
      }, d, {
        className: a()(f, p, i && "no-gutters")
      }));
    });
    l.defaultProps = {
      noGutters: !1
    }, t.a = l;
  },
  19: function _(e, t, n) {
    "use strict";

    var r = n(2),
        o = n(3),
        i = n(4),
        a = n.n(i),
        s = n(0),
        u = n.n(s),
        c = n(5),
        l = n(23),
        f = u.a.forwardRef(function (e, t) {
      var n = e.bsPrefix,
          i = e.variant,
          s = e.size,
          f = e.active,
          d = e.className,
          p = e.block,
          v = e.type,
          _ = e.as,
          h = Object(o.a)(e, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]),
          m = Object(c.b)(n, "btn"),
          y = a()(d, m, f && "active", m + "-" + i, p && m + "-block", s && m + "-" + s);
      if (h.href) return u.a.createElement(l.a, Object(r.a)({}, h, {
        as: _,
        ref: t,
        className: a()(y, h.disabled && "disabled")
      }));
      t && (h.ref = t), _ || (h.type = v);
      var g = _ || "button";
      return u.a.createElement(g, Object(r.a)({}, h, {
        className: y
      }));
    });
    f.displayName = "Button", f.defaultProps = {
      variant: "primary",
      active: !1,
      disabled: !1,
      type: "button"
    }, t.a = f;
  },
  2: function _(e, t, n) {
    "use strict";

    function r() {
      return (r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    n.d(t, "a", function () {
      return r;
    });
  },
  20: function _(e, t, n) {
    "use strict";

    var r = n(21);

    function o() {}

    function i() {}

    i.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, i, a) {
        if (a !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  },
  21: function _(e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  },
  23: function _(e, t, n) {
    "use strict";

    var r = n(2),
        o = n(3),
        i = n(0),
        a = n.n(i);

    var s = function s() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return t.filter(function (e) {
        return null != e;
      }).reduce(function (e, t) {
        if ("function" != typeof t) throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        return null === e ? t : function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }

          e.apply(this, r), t.apply(this, r);
        };
      }, null);
    };

    function u(e) {
      return !e || "#" === e.trim();
    }

    var c = a.a.forwardRef(function (e, t) {
      var n = e.as,
          i = void 0 === n ? "a" : n,
          c = e.disabled,
          l = e.onKeyDown,
          f = Object(o.a)(e, ["as", "disabled", "onKeyDown"]),
          d = function d(e) {
        var t = f.href,
            n = f.onClick;
        (c || u(t)) && e.preventDefault(), c ? e.stopPropagation() : n && n(e);
      };

      return u(f.href) && (f.role = f.role || "button", f.href = f.href || "#"), c && (f.tabIndex = -1, f["aria-disabled"] = !0), a.a.createElement(i, Object(r.a)({
        ref: t
      }, f, {
        onClick: d,
        onKeyDown: s(function (e) {
          " " === e.key && (e.preventDefault(), d(e));
        }, l)
      }));
    });
    c.displayName = "SafeAnchor";
    t.a = c;
  },
  3: function _(e, t, n) {
    "use strict";

    function r(e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }

    n.d(t, "a", function () {
      return r;
    });
  },
  30: function _(e, t, n) {
    (function (e) {
      var r = void 0 !== e && e || "undefined" != typeof self && self || window,
          o = Function.prototype.apply;

      function i(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new i(o.call(setTimeout, r, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new i(o.call(setInterval, r, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, n(31), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, n(13));
  },
  31: function _(e, t, n) {
    (function (e, t) {
      !function (e, n) {
        "use strict";

        if (!e.setImmediate) {
          var r,
              o,
              i,
              a,
              s,
              u = 1,
              c = {},
              l = !1,
              f = e.document,
              d = Object.getPrototypeOf && Object.getPrototypeOf(e);
          d = d && d.setTimeout ? d : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
            t.nextTick(function () {
              v(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  n = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = n, t;
            }
          }() ? e.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e) {
            v(e.data);
          }, r = function r(e) {
            i.port2.postMessage(e);
          }) : f && "onreadystatechange" in f.createElement("script") ? (o = f.documentElement, r = function r(e) {
            var t = f.createElement("script");
            t.onreadystatechange = function () {
              v(e), t.onreadystatechange = null, o.removeChild(t), t = null;
            }, o.appendChild(t);
          }) : r = function r(e) {
            setTimeout(v, 0, e);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && v(+t.data.slice(a.length));
          }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function r(t) {
            e.postMessage(a + t, "*");
          }), d.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) {
              t[n] = arguments[n + 1];
            }

            var o = {
              callback: e,
              args: t
            };
            return c[u] = o, r(u), u++;
          }, d.clearImmediate = p;
        }

        function p(e) {
          delete c[e];
        }

        function v(e) {
          if (l) setTimeout(v, 0, e);else {
            var t = c[e];

            if (t) {
              l = !0;

              try {
                !function (e) {
                  var t = e.callback,
                      r = e.args;

                  switch (r.length) {
                    case 0:
                      t();
                      break;

                    case 1:
                      t(r[0]);
                      break;

                    case 2:
                      t(r[0], r[1]);
                      break;

                    case 3:
                      t(r[0], r[1], r[2]);
                      break;

                    default:
                      t.apply(n, r);
                  }
                }(t);
              } finally {
                p(e), l = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, n(13), n(32));
  },
  32: function _(e, t) {
    var n,
        r,
        o = e.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        n = i;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var u,
        c = [],
        l = !1,
        f = -1;

    function d() {
      l && u && (l = !1, u.length ? c = u.concat(c) : f = -1, c.length && p());
    }

    function p() {
      if (!l) {
        var e = s(d);
        l = !0;

        for (var t = c.length; t;) {
          for (u = c, c = []; ++f < t;) {
            u && u[f].run();
          }

          f = -1, t = c.length;
        }

        u = null, l = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function v(e, t) {
      this.fun = e, this.array = t;
    }

    function _() {}

    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      c.push(new v(e, t)), 1 !== c.length || l || s(p);
    }, v.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = _, o.addListener = _, o.once = _, o.off = _, o.removeListener = _, o.removeAllListeners = _, o.emit = _, o.prependListener = _, o.prependOnceListener = _, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  },
  4: function _(e, t, n) {
    var r;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r) && r.length) {
              var a = o.apply(null, r);
              a && e.push(a);
            } else if ("object" === i) for (var s in r) {
              n.call(r, s) && r[s] && e.push(s);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(t, [])) || (e.exports = r);
    }();
  },
  46: function _(e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r);

    t.default = function (e) {
      return o.a.createElement("div", {
        style: {
          width: "".concat(e.percentage, "%"),
          background: "red",
          height: "100%",
          borderRadius: "inherit"
        }
      });
    };
  },
  5: function _(e, t, n) {
    "use strict";

    n.d(t, "b", function () {
      return c;
    }), n.d(t, "a", function () {
      return l;
    });
    var r = n(2),
        o = n(15),
        i = n.n(o),
        a = n(0),
        s = n.n(a),
        u = s.a.createContext({});
    u.Consumer, u.Provider;

    function c(e, t) {
      var n = Object(a.useContext)(u);
      return e || n[t] || t;
    }

    function l(e, t) {
      "string" == typeof t && (t = {
        prefix: t
      });
      var n = e.prototype && e.prototype.isReactComponent,
          o = t,
          a = o.prefix,
          u = o.forwardRefAs,
          l = void 0 === u ? n ? "ref" : "innerRef" : u;
      return i()(function (t, n) {
        var o = Object(r.a)({}, t);
        o[l] = n;
        var i = c(o.bsPrefix, a);
        return s.a.createElement(e, Object(r.a)({}, o, {
          bsPrefix: i
        }));
      }, {
        displayName: "Bootstrap(" + (e.displayName || e.name) + ")"
      });
    }
  },
  59: function _(e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r),
        i = n(46);

    t.default = function (e) {
      return o.a.createElement("div", {
        onClick: e.onClick,
        style: {
          position: "relative",
          height: "12px",
          width: "100%",
          opacity: "1"
        }
      }, o.a.createElement(i.default, {
        percentage: e.percentage
      }));
    };
  },
  6: function _(e, t, n) {
    "use strict";

    var r = n(2),
        o = n(3),
        i = n(4),
        a = n.n(i),
        s = n(0),
        u = n.n(s),
        c = n(5),
        l = ["xl", "lg", "md", "sm", "xs"],
        f = u.a.forwardRef(function (e, t) {
      var n = e.bsPrefix,
          i = e.className,
          s = e.as,
          f = void 0 === s ? "div" : s,
          d = Object(o.a)(e, ["bsPrefix", "className", "as"]),
          p = Object(c.b)(n, "col"),
          v = [],
          _ = [];
      return l.forEach(function (e) {
        var t,
            n,
            r,
            o = d[e];

        if (delete d[e], null != o && "object" == typeof o) {
          var i = o.span;
          t = void 0 === i || i, n = o.offset, r = o.order;
        } else t = o;

        var a = "xs" !== e ? "-" + e : "";
        null != t && v.push(!0 === t ? "" + p + a : "" + p + a + "-" + t), null != r && _.push("order" + a + "-" + r), null != n && _.push("offset" + a + "-" + n);
      }), v.length || v.push(p), u.a.createElement(f, Object(r.a)({}, d, {
        ref: t,
        className: a.a.apply(void 0, [i].concat(v, _))
      }));
    });
    f.displayName = "Col", t.a = f;
  },
  7: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    }), n.d(t, "b", function () {
      return o;
    }), n.d(t, "c", function () {
      return i;
    }), n.d(t, "d", function () {
      return a;
    }), n.d(t, "e", function () {
      return s;
    }), n.d(t, "f", function () {
      return u;
    }), n.d(t, "g", function () {
      return c;
    }), n.d(t, "h", function () {
      return l;
    }), n.d(t, "i", function () {
      return f;
    }), n.d(t, "j", function () {
      return d;
    }), n.d(t, "k", function () {
      return p;
    });
    var r = {
      prefix: "fas",
      iconName: "check",
      icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"]
    },
        o = {
      prefix: "fas",
      iconName: "exclamation-triangle",
      icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
    },
        i = {
      prefix: "fas",
      iconName: "grip-lines",
      icon: [512, 512, [], "f7a4", "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
    },
        a = {
      prefix: "fas",
      iconName: "microphone-alt",
      icon: [352, 512, [], "f3c9", "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"]
    },
        s = {
      prefix: "fas",
      iconName: "pause",
      icon: [448, 512, [], "f04c", "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"]
    },
        u = {
      prefix: "fas",
      iconName: "pen",
      icon: [512, 512, [], "f304", "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"]
    },
        c = {
      prefix: "fas",
      iconName: "play",
      icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"]
    },
        l = {
      prefix: "fas",
      iconName: "search",
      icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"]
    },
        f = {
      prefix: "fas",
      iconName: "sticky-note",
      icon: [448, 512, [], "f249", "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"]
    },
        d = {
      prefix: "fas",
      iconName: "stop",
      icon: [448, 512, [], "f04d", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
    },
        p = {
      prefix: "fas",
      iconName: "trash",
      icon: [448, 512, [], "f1f8", "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"]
    };
  },
  74: function _(e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r),
        i = n(59),
        a = n(1);

    function s(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var u = function u(e, t) {
      return e / t * 100;
    },
        c = function c(e) {
      var t = Object(r.useRef)(),
          n = s(Object(r.useState)(0), 2),
          a = n[0],
          c = n[1],
          l = s(Object(r.useState)(), 2),
          f = l[0],
          d = l[1],
          p = s(Object(r.useState)(0), 2),
          v = p[0],
          _ = p[1];
      return Object(r.useLayoutEffect)(function () {
        t.current && _(t.current.offsetWidth);
      }, [t]), Object(r.useEffect)(function () {
        var t = function t() {
          var e = u(f.currentTime, f.duration);
          c(e), requestAnimationFrame(t);
        };

        d(e.videoContext), f && t();
      }, [e.videoContext, f]), o.a.createElement("div", {
        ref: t,
        style: {
          width: "100%"
        }
      }, o.a.createElement(i.default, {
        onClick: function onClick(e) {
          var t = e.nativeEvent.offsetX;
          f.currentTime = t / v * f.duration;
          var n = u(f.currentTime, f.duration);
          c(n);
        },
        percentage: a
      }));
    };

    c.propTypes = {
      videoContext: n.n(a).a.any
    }, t.default = c;
  },
  75: function _(e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r),
        i = n(19),
        a = n(6),
        s = n(9),
        u = n(7),
        c = n(1),
        l = n.n(c);

    function f(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var d = o.a.createElement(s.a, {
      icon: u.g
    }),
        p = o.a.createElement(s.a, {
      icon: u.e
    }),
        v = o.a.createElement(s.a, {
      icon: u.j
    }),
        _ = function _(e) {
      var t = f(Object(r.useState)(!1), 2),
          n = t[0],
          s = t[1];
      return o.a.createElement(o.a.Fragment, null, o.a.createElement(a.a, {
        sm: 6
      }, o.a.createElement(i.a, {
        size: "sm",
        block: !0,
        variant: "outline-secondary",
        onClick: n ? function () {
          e.handlePause(), s(!1);
        } : function () {
          e.handlePlay(), s(!0);
        }
      }, n ? p : d)), o.a.createElement(a.a, {
        sm: 6
      }, o.a.createElement(i.a, {
        size: "sm",
        block: !0,
        variant: "outline-secondary",
        onClick: function onClick() {
          e.handleStop(), s(!1);
        }
      }, v)));
    };

    t.default = _, _.propTypes = {
      handleStop: l.a.any,
      handlePlay: l.a.any,
      handlePause: l.a.any
    };
  },
  9: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return m;
    });
    var r = n(14),
        o = n(1),
        i = n.n(o),
        a = n(0),
        s = n.n(a);

    function u(e) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function c(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function l(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
            r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function (t) {
          c(e, t, n[t]);
        });
      }

      return e;
    }

    function f(e, t) {
      if (null == e) return {};

      var n,
          r,
          o = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            i = Object.keys(e);

        for (r = 0; r < i.length; r++) {
          n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (r = 0; r < i.length; r++) {
          n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
      }

      return o;
    }

    function d(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function p(e) {
      return t = e, (t -= 0) == t ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
        return t ? t.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + e.substr(1);
      var t;
    }

    var v = !1;

    try {
      v = !0;
    } catch (e) {}

    function _(e) {
      return null === e ? null : "object" === u(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
        prefix: e[0],
        iconName: e[1]
      } : "string" == typeof e ? {
        prefix: "fas",
        iconName: e
      } : void 0;
    }

    function h(e, t) {
      return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? c({}, e, t) : {};
    }

    function m(e) {
      var t = e.icon,
          n = e.mask,
          o = e.symbol,
          i = e.className,
          a = e.title,
          s = _(t),
          u = h("classes", [].concat(d(function (e) {
        var t,
            n = e.spin,
            r = e.pulse,
            o = e.fixedWidth,
            i = e.inverse,
            a = e.border,
            s = e.listItem,
            u = e.flip,
            l = e.size,
            f = e.rotation,
            d = e.pull,
            p = (c(t = {
          "fa-spin": n,
          "fa-pulse": r,
          "fa-fw": o,
          "fa-inverse": i,
          "fa-border": a,
          "fa-li": s,
          "fa-flip-horizontal": "horizontal" === u || "both" === u,
          "fa-flip-vertical": "vertical" === u || "both" === u
        }, "fa-".concat(l), null != l), c(t, "fa-rotate-".concat(f), null != f), c(t, "fa-pull-".concat(d), null != d), c(t, "fa-swap-opacity", e.swapOpacity), t);
        return Object.keys(p).map(function (e) {
          return p[e] ? e : null;
        }).filter(function (e) {
          return e;
        });
      }(e)), d(i.split(" ")))),
          f = h("transform", "string" == typeof e.transform ? r.b.transform(e.transform) : e.transform),
          p = h("mask", _(n)),
          g = Object(r.a)(s, l({}, u, f, p, {
        symbol: o,
        title: a
      }));

      if (!g) return function () {
        var e;
        !v && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
      }("Could not find icon", s), null;
      var b = g.abstract,
          x = {};
      return Object.keys(e).forEach(function (t) {
        m.defaultProps.hasOwnProperty(t) || (x[t] = e[t]);
      }), y(b[0], x);
    }

    m.displayName = "FontAwesomeIcon", m.propTypes = {
      border: i.a.bool,
      className: i.a.string,
      mask: i.a.oneOfType([i.a.object, i.a.array, i.a.string]),
      fixedWidth: i.a.bool,
      inverse: i.a.bool,
      flip: i.a.oneOf(["horizontal", "vertical", "both"]),
      icon: i.a.oneOfType([i.a.object, i.a.array, i.a.string]),
      listItem: i.a.bool,
      pull: i.a.oneOf(["right", "left"]),
      pulse: i.a.bool,
      rotation: i.a.oneOf([90, 180, 270]),
      size: i.a.oneOf(["lg", "xs", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
      spin: i.a.bool,
      symbol: i.a.oneOfType([i.a.bool, i.a.string]),
      title: i.a.string,
      transform: i.a.oneOfType([i.a.string, i.a.object]),
      swapOpacity: i.a.bool
    }, m.defaultProps = {
      border: !1,
      className: "",
      mask: null,
      fixedWidth: !1,
      inverse: !1,
      flip: null,
      icon: null,
      listItem: !1,
      pull: null,
      pulse: !1,
      rotation: null,
      size: null,
      spin: !1,
      symbol: !1,
      title: "",
      transform: null,
      swapOpacity: !1
    };

    var y = function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if ("string" == typeof n) return n;
      var o = (n.children || []).map(function (n) {
        return e(t, n);
      }),
          i = Object.keys(n.attributes || {}).reduce(function (e, t) {
        var r = n.attributes[t];

        switch (t) {
          case "class":
            e.attrs.className = r, delete n.attributes.class;
            break;

          case "style":
            e.attrs.style = r.split(";").map(function (e) {
              return e.trim();
            }).filter(function (e) {
              return e;
            }).reduce(function (e, t) {
              var n,
                  r = t.indexOf(":"),
                  o = p(t.slice(0, r)),
                  i = t.slice(r + 1).trim();
              return o.startsWith("webkit") ? e[(n = o, n.charAt(0).toUpperCase() + n.slice(1))] = i : e[o] = i, e;
            }, {});
            break;

          default:
            0 === t.indexOf("aria-") || 0 === t.indexOf("data-") ? e.attrs[t.toLowerCase()] = r : e.attrs[p(t)] = r;
        }

        return e;
      }, {
        attrs: {}
      }),
          a = r.style,
          s = void 0 === a ? {} : a,
          u = f(r, ["style"]);
      return i.attrs.style = l({}, i.attrs.style, s), t.apply(void 0, [n.tag, l({}, i.attrs, u)].concat(d(o)));
    }.bind(null, s.a.createElement);
  },
  97: function _(e, t, n) {
    var r;
    window, r = function r() {
      return function (e) {
        var t = {};

        function n(r) {
          if (t[r]) return t[r].exports;
          var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }

        return n.m = e, n.c = t, n.d = function (e, t, r) {
          n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
          });
        }, n.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, n.t = function (e, t) {
          if (1 & t && (e = n(e)), 8 & t) return e;
          if (4 & t && "object" == typeof e && e && e.__esModule) return e;
          var r = Object.create(null);
          if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var o in e) {
            n.d(r, o, function (t) {
              return e[t];
            }.bind(null, o));
          }
          return r;
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = "./src/videocontext.js");
      }({
        "./src/Definitions/aaf_video_crop/aaf_video_crop.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_crop/aaf_video_crop.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_cropAaf_video_cropFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float cropLeft;\nuniform float cropRight;\nuniform float cropTop;\nuniform float cropBottom;\nvarying vec2 v_texCoord;\nvoid main(){\n    vec4 color = texture2D(u_image, v_texCoord);\n    if (v_texCoord[0] < (cropLeft+1.0)/2.0) color = vec4(0.0,0.0,0.0,0.0);\n    if (v_texCoord[0] > (cropRight+1.0)/2.0) color = vec4(0.0,0.0,0.0,0.0);\n    if (v_texCoord[1] < (-cropBottom+1.0)/2.0) color = vec4(0.0,0.0,0.0,0.0);\n    if (v_texCoord[1] > (-cropTop+1.0)/2.0) color = vec4(0.0,0.0,0.0,0.0);\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/aaf_video_crop/aaf_video_crop.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/aaf_video_crop/aaf_video_crop.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_cropAaf_video_cropJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./aaf_video_crop.vert */
          "./src/Definitions/aaf_video_crop/aaf_video_crop.vert"), n(
          /*! ./aaf_video_crop.frag */
          "./src/Definitions/aaf_video_crop/aaf_video_crop.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "AAF Video Crop Effect",
              description: "A crop effect based on the AAF spec.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                cropLeft: {
                  type: "uniform",
                  value: -1
                },
                cropRight: {
                  type: "uniform",
                  value: 1
                },
                cropTop: {
                  type: "uniform",
                  value: -1
                },
                cropBottom: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/aaf_video_crop/aaf_video_crop.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_crop/aaf_video_crop.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_cropAaf_video_cropVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/aaf_video_flip/aaf_video_flip.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_flip/aaf_video_flip.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_flipAaf_video_flipFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvoid main(){\n    vec2 coord = vec2(v_texCoord[0] ,1.0 - v_texCoord[1]);\n    vec4 color = texture2D(u_image, coord);\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/aaf_video_flip/aaf_video_flip.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/aaf_video_flip/aaf_video_flip.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_flipAaf_video_flipJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./aaf_video_flip.vert */
          "./src/Definitions/aaf_video_flip/aaf_video_flip.vert"), n(
          /*! ./aaf_video_flip.frag */
          "./src/Definitions/aaf_video_flip/aaf_video_flip.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r2) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r2);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "AAF Video Flip Effect",
              description: "A flip effect based on the AAF spec. Mirrors the image in the x-axis",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {},
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/aaf_video_flip/aaf_video_flip.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_flip/aaf_video_flip.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_flipAaf_video_flipVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/aaf_video_flop/aaf_video_flop.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_flop/aaf_video_flop.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_flopAaf_video_flopFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvoid main(){\n    vec2 coord = vec2(1.0 - v_texCoord[0] ,v_texCoord[1]);\n    vec4 color = texture2D(u_image, coord);\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/aaf_video_flop/aaf_video_flop.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/aaf_video_flop/aaf_video_flop.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_flopAaf_video_flopJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./aaf_video_flop.vert */
          "./src/Definitions/aaf_video_flop/aaf_video_flop.vert"), n(
          /*! ./aaf_video_flop.frag */
          "./src/Definitions/aaf_video_flop/aaf_video_flop.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r3) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r3);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "AAF Video Flop Effect",
              description: "A flop effect based on the AAF spec. Mirrors the image in the y-axis",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {},
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/aaf_video_flop/aaf_video_flop.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_flop/aaf_video_flop.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_flopAaf_video_flopVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/aaf_video_position/aaf_video_position.frag":
        /*!********************************************************************!*\
          !*** ./src/Definitions/aaf_video_position/aaf_video_position.frag ***!
          \********************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_positionAaf_video_positionFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float positionOffsetX;\nuniform float positionOffsetY;\nvarying vec2 v_texCoord;\nvarying float v_progress;\nvoid main(){\n    vec2 pos = vec2(v_texCoord[0] - positionOffsetX/2.0, v_texCoord[1] -  positionOffsetY/2.0);\n    vec4 color = texture2D(u_image, pos);\n    if (pos[0] < 0.0 || pos[0] > 1.0 || pos[1] < 0.0 || pos[1] > 1.0){\n        color = vec4(0.0,0.0,0.0,0.0);\n    }\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/aaf_video_position/aaf_video_position.js":
        /*!******************************************************************!*\
          !*** ./src/Definitions/aaf_video_position/aaf_video_position.js ***!
          \******************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_positionAaf_video_positionJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./aaf_video_position.vert */
          "./src/Definitions/aaf_video_position/aaf_video_position.vert"), n(
          /*! ./aaf_video_position.frag */
          "./src/Definitions/aaf_video_position/aaf_video_position.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r4) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r4);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "AAF Video Position Effect",
              description: "A position effect based on the AAF spec.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                positionOffsetX: {
                  type: "uniform",
                  value: 0
                },
                positionOffsetY: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/aaf_video_position/aaf_video_position.vert":
        /*!********************************************************************!*\
          !*** ./src/Definitions/aaf_video_position/aaf_video_position.vert ***!
          \********************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_positionAaf_video_positionVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/aaf_video_scale/aaf_video_scale.frag":
        /*!**************************************************************!*\
          !*** ./src/Definitions/aaf_video_scale/aaf_video_scale.frag ***!
          \**************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_scaleAaf_video_scaleFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float scaleX;\nuniform float scaleY;\nvarying vec2 v_texCoord;\nvarying float v_progress;\nvoid main(){\n    vec2 pos = vec2(v_texCoord[0]*1.0/scaleX - (1.0/scaleX/2.0 -0.5), v_texCoord[1]*1.0/scaleY - (1.0/scaleY/2.0 -0.5));\n    vec4 color = texture2D(u_image, pos);\n    if (pos[0] < 0.0 || pos[0] > 1.0 || pos[1] < 0.0 || pos[1] > 1.0){\n        color = vec4(0.0,0.0,0.0,0.0);\n    }\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/aaf_video_scale/aaf_video_scale.js":
        /*!************************************************************!*\
          !*** ./src/Definitions/aaf_video_scale/aaf_video_scale.js ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_scaleAaf_video_scaleJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./aaf_video_scale.vert */
          "./src/Definitions/aaf_video_scale/aaf_video_scale.vert"), n(
          /*! ./aaf_video_scale.frag */
          "./src/Definitions/aaf_video_scale/aaf_video_scale.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r5) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r5);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "AAF Video Scale Effect",
              description: "A scale effect based on the AAF spec.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                scaleX: {
                  type: "uniform",
                  value: 1
                },
                scaleY: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/aaf_video_scale/aaf_video_scale.vert":
        /*!**************************************************************!*\
          !*** ./src/Definitions/aaf_video_scale/aaf_video_scale.vert ***!
          \**************************************************************/

        /*! no static exports found */
        function srcDefinitionsAaf_video_scaleAaf_video_scaleVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/colorThreshold/colorThreshold.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/colorThreshold/colorThreshold.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsColorThresholdColorThresholdFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float a;\nuniform vec3 colorAlphaThreshold;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color = texture2D(u_image, v_texCoord);\n    if (color[0] > colorAlphaThreshold[0] && color[1]> colorAlphaThreshold[1] && color[2]> colorAlphaThreshold[2]){\n        color = vec4(0.0,0.0,0.0,0.0);\n    }\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/colorThreshold/colorThreshold.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/colorThreshold/colorThreshold.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsColorThresholdColorThresholdJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./colorThreshold.vert */
          "./src/Definitions/colorThreshold/colorThreshold.vert"), n(
          /*! ./colorThreshold.frag */
          "./src/Definitions/colorThreshold/colorThreshold.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r6) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r6);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Color Threshold",
              description: "Turns all pixels with a greater value than the specified threshold transparent.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                a: {
                  type: "uniform",
                  value: 0
                },
                colorAlphaThreshold: {
                  type: "uniform",
                  value: [0, .55, 0]
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/colorThreshold/colorThreshold.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/colorThreshold/colorThreshold.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsColorThresholdColorThresholdVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/combine/combine.frag":
        /*!**********************************************!*\
          !*** ./src/Definitions/combine/combine.frag ***!
          \**********************************************/

        /*! no static exports found */
        function srcDefinitionsCombineCombineFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float a;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color = texture2D(u_image, v_texCoord);\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/combine/combine.js":
        /*!********************************************!*\
          !*** ./src/Definitions/combine/combine.js ***!
          \********************************************/

        /*! no static exports found */
        function srcDefinitionsCombineCombineJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./combine.vert */
          "./src/Definitions/combine/combine.vert"), n(
          /*! ./combine.frag */
          "./src/Definitions/combine/combine.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r7) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r7);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Combine",
              description: "A basic effect which renders the input to the output, Typically used as a combine node for layering up media with alpha transparency.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                a: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/combine/combine.vert":
        /*!**********************************************!*\
          !*** ./src/Definitions/combine/combine.vert ***!
          \**********************************************/

        /*! no static exports found */
        function srcDefinitionsCombineCombineVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/crop/crop.frag":
        /*!****************************************!*\
          !*** ./src/Definitions/crop/crop.frag ***!
          \****************************************/

        /*! no static exports found */
        function srcDefinitionsCropCropFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float x;\nuniform float y;\nuniform float width;\nuniform float height;\nvarying vec2 v_texCoord;\nvarying float v_progress;\nvoid main(){\n    vec2 pos = (((v_texCoord)*vec2(width, height)) + vec2(0, 1.0-height)) +vec2(x,-y);\n    vec4 color = texture2D(u_image, pos);\n    if (pos[0] < 0.0 || pos[0] > 1.0 || pos[1] < 0.0 || pos[1] > 1.0){\n        color = vec4(0.0,0.0,0.0,0.0);\n    }\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/crop/crop.js":
        /*!**************************************!*\
          !*** ./src/Definitions/crop/crop.js ***!
          \**************************************/

        /*! no static exports found */
        function srcDefinitionsCropCropJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./crop.vert */
          "./src/Definitions/crop/crop.vert"), n(
          /*! ./crop.frag */
          "./src/Definitions/crop/crop.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r8) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r8);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Primer Simple Crop",
              description: "A simple crop processors for primer",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                x: {
                  type: "uniform",
                  value: 0
                },
                y: {
                  type: "uniform",
                  value: 0
                },
                width: {
                  type: "uniform",
                  value: 1
                },
                height: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/crop/crop.vert":
        /*!****************************************!*\
          !*** ./src/Definitions/crop/crop.vert ***!
          \****************************************/

        /*! no static exports found */
        function srcDefinitionsCropCropVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/crossfade/crossfade.frag":
        /*!**************************************************!*\
          !*** ./src/Definitions/crossfade/crossfade.frag ***!
          \**************************************************/

        /*! no static exports found */
        function srcDefinitionsCrossfadeCrossfadeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color_a = texture2D(u_image_a, v_texCoord);\n    vec4 color_b = texture2D(u_image_b, v_texCoord);\n    color_a[0] *= (1.0 - mix);\n    color_a[1] *= (1.0 - mix);\n    color_a[2] *= (1.0 - mix);\n    color_a[3] *= (1.0 - mix);\n    color_b[0] *= mix;\n    color_b[1] *= mix;\n    color_b[2] *= mix;\n    color_b[3] *= mix;\n    gl_FragColor = color_a + color_b;\n}\n";
        },
        "./src/Definitions/crossfade/crossfade.js":
        /*!************************************************!*\
          !*** ./src/Definitions/crossfade/crossfade.js ***!
          \************************************************/

        /*! no static exports found */
        function srcDefinitionsCrossfadeCrossfadeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./crossfade.vert */
          "./src/Definitions/crossfade/crossfade.vert"), n(
          /*! ./crossfade.frag */
          "./src/Definitions/crossfade/crossfade.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r9) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r9);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Cross-Fade",
              description: "A cross-fade effect. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/crossfade/crossfade.vert":
        /*!**************************************************!*\
          !*** ./src/Definitions/crossfade/crossfade.vert ***!
          \**************************************************/

        /*! no static exports found */
        function srcDefinitionsCrossfadeCrossfadeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/definitions.js":
        /*!****************************************!*\
          !*** ./src/Definitions/definitions.js ***!
          \****************************************/

        /*! no static exports found */
        function srcDefinitionsDefinitionsJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./aaf_video_scale */
          "./src/Definitions/aaf_video_scale/aaf_video_scale.js"), n(
          /*! ./crossfade */
          "./src/Definitions/crossfade/crossfade.js"), n(
          /*! ./horizontalWipe */
          "./src/Definitions/horizontalWipe/horizontalWipe.js"), n(
          /*! ./verticalWipe */
          "./src/Definitions/verticalWipe/verticalWipe.js"), n(
          /*! ./randomDissolve */
          "./src/Definitions/randomDissolve/randomDissolve.js"), n(
          /*! ./toColorAndBackFade */
          "./src/Definitions/toColorAndBackFade/toColorAndBackFade.js"), n(
          /*! ./starWipe */
          "./src/Definitions/starWipe/starWipe.js"), n(
          /*! ./combine */
          "./src/Definitions/combine/combine.js"), n(
          /*! ./colorThreshold */
          "./src/Definitions/colorThreshold/colorThreshold.js"), n(
          /*! ./monochrome */
          "./src/Definitions/monochrome/monochrome.js"), n(
          /*! ./horizontalBlur */
          "./src/Definitions/horizontalBlur/horizontalBlur.js"), n(
          /*! ./verticalBlur */
          "./src/Definitions/verticalBlur/verticalBlur.js"), n(
          /*! ./aaf_video_flop */
          "./src/Definitions/aaf_video_flop/aaf_video_flop.js"), n(
          /*! ./aaf_video_flip */
          "./src/Definitions/aaf_video_flip/aaf_video_flip.js"), n(
          /*! ./aaf_video_position */
          "./src/Definitions/aaf_video_position/aaf_video_position.js"), n(
          /*! ./aaf_video_crop */
          "./src/Definitions/aaf_video_crop/aaf_video_crop.js"), n(
          /*! ./staticDissolve */
          "./src/Definitions/staticDissolve/staticDissolve.js"), n(
          /*! ./staticEffect */
          "./src/Definitions/staticEffect/staticEffect.js"), n(
          /*! ./dreamfade */
          "./src/Definitions/dreamfade/dreamfade.js"), n(
          /*! ./opacity */
          "./src/Definitions/opacity/opacity.js"), n(
          /*! ./crop */
          "./src/Definitions/crop/crop.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r10, o, i, a, s, u, c, l, f, d, p, v, _, h, m, y, g, b, x, T) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var E = G(n),
                C = G(_r10),
                O = G(o),
                w = G(i),
                S = G(a),
                A = G(s),
                k = G(u),
                P = G(c),
                N = G(l),
                D = G(f),
                j = G(d),
                R = G(p),
                F = G(v),
                M = G(_),
                I = G(h),
                U = G(m),
                L = G(y),
                z = G(g),
                W = G(b),
                B = G(x),
                V = G(T);

            function G(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var Y = {
              AAF_VIDEO_SCALE: E.default,
              CROSSFADE: C.default,
              DREAMFADE: W.default,
              HORIZONTAL_WIPE: O.default,
              VERTICAL_WIPE: w.default,
              RANDOM_DISSOLVE: S.default,
              STATIC_DISSOLVE: L.default,
              STATIC_EFFECT: z.default,
              TO_COLOR_AND_BACK: A.default,
              STAR_WIPE: k.default,
              COMBINE: P.default,
              COLORTHRESHOLD: N.default,
              MONOCHROME: D.default,
              HORIZONTAL_BLUR: j.default,
              VERTICAL_BLUR: R.default,
              AAF_VIDEO_CROP: U.default,
              AAF_VIDEO_POSITION: I.default,
              AAF_VIDEO_FLIP: M.default,
              AAF_VIDEO_FLOP: F.default,
              OPACITY: B.default,
              CROP: V.default
            };
            t.default = Y, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/dreamfade/dreamfade.frag":
        /*!**************************************************!*\
          !*** ./src/Definitions/dreamfade/dreamfade.frag ***!
          \**************************************************/

        /*! no static exports found */
        function srcDefinitionsDreamfadeDreamfadeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    float wobble = 1.0 - abs((mix*2.0)-1.0);\n    vec2 pos = vec2(v_texCoord[0] + ((sin(v_texCoord[1]*(10.0*wobble*3.14) + wobble*10.0)/13.0)), v_texCoord[1]);\n    vec4 color_a = texture2D(u_image_a, pos);\n    vec4 color_b = texture2D(u_image_b, pos);\n    color_a[0] *= (1.0 - mix);\n    color_a[1] *= (1.0 - mix);\n    color_a[2] *= (1.0 - mix);\n    color_a[3] *= (1.0 - mix);\n    color_b[0] *= mix;\n    color_b[1] *= mix;\n    color_b[2] *= mix;\n    color_b[3] *= mix;\n    gl_FragColor = color_a + color_b;\n}\n";
        },
        "./src/Definitions/dreamfade/dreamfade.js":
        /*!************************************************!*\
          !*** ./src/Definitions/dreamfade/dreamfade.js ***!
          \************************************************/

        /*! no static exports found */
        function srcDefinitionsDreamfadeDreamfadeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./dreamfade.vert */
          "./src/Definitions/dreamfade/dreamfade.vert"), n(
          /*! ./dreamfade.frag */
          "./src/Definitions/dreamfade/dreamfade.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r11) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r11);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Dream-Fade",
              description: "A wobbly dream effect. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/dreamfade/dreamfade.vert":
        /*!**************************************************!*\
          !*** ./src/Definitions/dreamfade/dreamfade.vert ***!
          \**************************************************/

        /*! no static exports found */
        function srcDefinitionsDreamfadeDreamfadeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/horizontalBlur/horizontalBlur.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/horizontalBlur/horizontalBlur.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsHorizontalBlurHorizontalBlurFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec2 v_blurTexCoords[14];\nvoid main(){\n    gl_FragColor = vec4(0.0);\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 0])*0.0044299121055113265;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 1])*0.00895781211794;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 2])*0.0215963866053;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 3])*0.0443683338718;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 4])*0.0776744219933;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 5])*0.115876621105;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 6])*0.147308056121;\n    gl_FragColor += texture2D(u_image, v_texCoord         )*0.159576912161;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 7])*0.147308056121;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 8])*0.115876621105;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 9])*0.0776744219933;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[10])*0.0443683338718;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[11])*0.0215963866053;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[12])*0.00895781211794;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[13])*0.0044299121055113265;\n}\n";
        },
        "./src/Definitions/horizontalBlur/horizontalBlur.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/horizontalBlur/horizontalBlur.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsHorizontalBlurHorizontalBlurJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./horizontalBlur.vert */
          "./src/Definitions/horizontalBlur/horizontalBlur.vert"), n(
          /*! ./horizontalBlur.frag */
          "./src/Definitions/horizontalBlur/horizontalBlur.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r12) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r12);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Horizontal Blur",
              description: "A horizontal blur effect. Adpated from http://xissburg.com/faster-gaussian-blur-in-glsl/",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                blurAmount: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/horizontalBlur/horizontalBlur.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/horizontalBlur/horizontalBlur.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsHorizontalBlurHorizontalBlurVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nuniform float blurAmount;\nvarying vec2 v_texCoord;\nvarying vec2 v_blurTexCoords[14];\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n    v_blurTexCoords[ 0] = v_texCoord + vec2(-0.028 * blurAmount, 0.0);\n    v_blurTexCoords[ 1] = v_texCoord + vec2(-0.024 * blurAmount, 0.0);\n    v_blurTexCoords[ 2] = v_texCoord + vec2(-0.020 * blurAmount, 0.0);\n    v_blurTexCoords[ 3] = v_texCoord + vec2(-0.016 * blurAmount, 0.0);\n    v_blurTexCoords[ 4] = v_texCoord + vec2(-0.012 * blurAmount, 0.0);\n    v_blurTexCoords[ 5] = v_texCoord + vec2(-0.008 * blurAmount, 0.0);\n    v_blurTexCoords[ 6] = v_texCoord + vec2(-0.004 * blurAmount, 0.0);\n    v_blurTexCoords[ 7] = v_texCoord + vec2( 0.004 * blurAmount, 0.0);\n    v_blurTexCoords[ 8] = v_texCoord + vec2( 0.008 * blurAmount, 0.0);\n    v_blurTexCoords[ 9] = v_texCoord + vec2( 0.012 * blurAmount, 0.0);\n    v_blurTexCoords[10] = v_texCoord + vec2( 0.016 * blurAmount, 0.0);\n    v_blurTexCoords[11] = v_texCoord + vec2( 0.020 * blurAmount, 0.0);\n    v_blurTexCoords[12] = v_texCoord + vec2( 0.024 * blurAmount, 0.0);\n    v_blurTexCoords[13] = v_texCoord + vec2( 0.028 * blurAmount, 0.0);\n}\n";
        },
        "./src/Definitions/horizontalWipe/horizontalWipe.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/horizontalWipe/horizontalWipe.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsHorizontalWipeHorizontalWipeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color_a = texture2D(u_image_a, v_texCoord);\n    vec4 color_b = texture2D(u_image_b, v_texCoord);\n    if (v_texCoord[0] > mix){\n        gl_FragColor = color_a;\n    } else {\n        gl_FragColor = color_b;\n    }\n}\n";
        },
        "./src/Definitions/horizontalWipe/horizontalWipe.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/horizontalWipe/horizontalWipe.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsHorizontalWipeHorizontalWipeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./horizontalWipe.vert */
          "./src/Definitions/horizontalWipe/horizontalWipe.vert"), n(
          /*! ./horizontalWipe.frag */
          "./src/Definitions/horizontalWipe/horizontalWipe.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r13) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r13);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Horizontal Wipe",
              description: "A horizontal wipe effect. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/horizontalWipe/horizontalWipe.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/horizontalWipe/horizontalWipe.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsHorizontalWipeHorizontalWipeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/monochrome/monochrome.frag":
        /*!****************************************************!*\
          !*** ./src/Definitions/monochrome/monochrome.frag ***!
          \****************************************************/

        /*! no static exports found */
        function srcDefinitionsMonochromeMonochromeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform vec3 inputMix;\nuniform vec3 outputMix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color = texture2D(u_image, v_texCoord);\n    float mono = color[0]*inputMix[0] + color[1]*inputMix[1] + color[2]*inputMix[2];\n    color[0] = mono * outputMix[0];\n    color[1] = mono * outputMix[1];\n    color[2] = mono * outputMix[2];\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/monochrome/monochrome.js":
        /*!**************************************************!*\
          !*** ./src/Definitions/monochrome/monochrome.js ***!
          \**************************************************/

        /*! no static exports found */
        function srcDefinitionsMonochromeMonochromeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./monochrome.vert */
          "./src/Definitions/monochrome/monochrome.vert"), n(
          /*! ./monochrome.frag */
          "./src/Definitions/monochrome/monochrome.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r14) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r14);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Monochrome",
              description: "Change images to a single chroma (e.g can be used to make a black & white filter). Input color mix and output color mix can be adjusted.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                inputMix: {
                  type: "uniform",
                  value: [.4, .6, .2]
                },
                outputMix: {
                  type: "uniform",
                  value: [1, 1, 1]
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/monochrome/monochrome.vert":
        /*!****************************************************!*\
          !*** ./src/Definitions/monochrome/monochrome.vert ***!
          \****************************************************/

        /*! no static exports found */
        function srcDefinitionsMonochromeMonochromeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/opacity/opacity.frag":
        /*!**********************************************!*\
          !*** ./src/Definitions/opacity/opacity.frag ***!
          \**********************************************/

        /*! no static exports found */
        function srcDefinitionsOpacityOpacityFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float opacity;\nvarying vec2 v_texCoord;\nvarying float v_opacity;\nvoid main(){\n    vec4 color = texture2D(u_image, v_texCoord);\n    color[3] *= opacity;\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/opacity/opacity.js":
        /*!********************************************!*\
          !*** ./src/Definitions/opacity/opacity.js ***!
          \********************************************/

        /*! no static exports found */
        function srcDefinitionsOpacityOpacityJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./opacity.vert */
          "./src/Definitions/opacity/opacity.vert"), n(
          /*! ./opacity.frag */
          "./src/Definitions/opacity/opacity.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r15) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r15);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Opacity",
              description: "Sets the opacity of an input.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                opacity: {
                  type: "uniform",
                  value: .7
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/opacity/opacity.vert":
        /*!**********************************************!*\
          !*** ./src/Definitions/opacity/opacity.vert ***!
          \**********************************************/

        /*! no static exports found */
        function srcDefinitionsOpacityOpacityVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/randomDissolve/randomDissolve.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/randomDissolve/randomDissolve.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsRandomDissolveRandomDissolveFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nfloat rand(vec2 co){\n    return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\n}\nvoid main(){\n    vec4 color_a = texture2D(u_image_a, v_texCoord);\n    vec4 color_b = texture2D(u_image_b, v_texCoord);\n    if (clamp(rand(v_texCoord),  0.01, 1.001) > mix){\n        gl_FragColor = color_a;\n    } else {\n        gl_FragColor = color_b;\n    }\n}\n";
        },
        "./src/Definitions/randomDissolve/randomDissolve.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/randomDissolve/randomDissolve.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsRandomDissolveRandomDissolveJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./randomDissolve.vert */
          "./src/Definitions/randomDissolve/randomDissolve.vert"), n(
          /*! ./randomDissolve.frag */
          "./src/Definitions/randomDissolve/randomDissolve.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r16) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r16);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Random Dissolve",
              description: "A random dissolve effect. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/randomDissolve/randomDissolve.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/randomDissolve/randomDissolve.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsRandomDissolveRandomDissolveVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/starWipe/starWipe.frag":
        /*!************************************************!*\
          !*** ./src/Definitions/starWipe/starWipe.frag ***!
          \************************************************/

        /*! no static exports found */
        function srcDefinitionsStarWipeStarWipeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nfloat sign (vec2 p1, vec2 p2, vec2 p3){\n    return (p1[0] - p3[0]) * (p2[1] - p3[1]) - (p2[0] - p3[0]) * (p1[1] - p3[1]);\n}\nbool pointInTriangle(vec2 pt, vec2 v1, vec2 v2, vec2 v3){\n    bool b1, b2, b3;\n    b1 = sign(pt, v1, v2) < 0.0;\n    b2 = sign(pt, v2, v3) < 0.0;\n    b3 = sign(pt, v3, v1) < 0.0;\n    return ((b1 == b2) && (b2 == b3));\n}\nvec2 rotatePointAboutPoint(vec2 point, vec2 pivot, float angle){\n    float s = sin(angle);\n    float c = cos(angle);\n    float x = point[0] - pivot[0];\n    float y = point[1] - pivot[1];\n    float new_x = x * c - y * s;\n    float new_y = x * s + y * c;\n    return vec2(new_x + pivot[0], new_y+pivot[1]);\n}\n\nvoid main(){\n    vec4 color_a = texture2D(u_image_b, v_texCoord);\n    vec4 color_b = texture2D(u_image_a, v_texCoord);\n    vec2 t0_p0,t0_p1,t0_p2,t1_p0,t1_p1,t1_p2,t2_p0,t2_p1,t2_p2,t3_p0,t3_p1,t3_p2;\n    vec2 t4_p0,t4_p1,t4_p2,t5_p0,t5_p1,t5_p2,t6_p0,t6_p1,t6_p2,t7_p0,t7_p1,t7_p2;\n\n\n    t0_p0 = vec2(0.0, 0.25) * clamp(mix,0.0,1.0) * 2.0 + vec2(0.5,0.5);\n    t0_p1 = vec2(0.0, -0.25) * clamp(mix,0.0,1.0) * 2.0 + vec2(0.5,0.5);\n    t0_p2 = vec2(1.0, 0.0) * clamp(mix,0.0,1.0) * 2.0 + vec2(0.5,0.5);\n\n    t1_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854);\n    t1_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854);\n    t1_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854);\n\n    t2_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854 * 2.0);\n    t2_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854 * 2.0);\n    t2_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854 * 2.0);\n\n    t3_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854 * 3.0);\n    t3_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854 * 3.0);\n    t3_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854 * 3.0);\n\n    t4_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854 * 4.0);\n    t4_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854 * 4.0);\n    t4_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854 * 4.0);\n\n    t5_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854 * 5.0);\n    t5_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854 * 5.0);\n    t5_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854 * 5.0);\n\n    t6_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854 * 6.0);\n    t6_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854 * 6.0);\n    t6_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854 * 6.0);\n\n    t7_p0 = rotatePointAboutPoint(t0_p0, vec2(0.5,0.5), 0.7854 * 7.0);\n    t7_p1 = rotatePointAboutPoint(t0_p1, vec2(0.5,0.5), 0.7854 * 7.0);\n    t7_p2 = rotatePointAboutPoint(t0_p2, vec2(0.5,0.5), 0.7854 * 7.0);\n\n    if(mix > 0.99){\n        gl_FragColor = color_a;\n        return;\n    }\n    if(mix < 0.01){\n        gl_FragColor = color_b;\n        return;\n    }\n    if(pointInTriangle(v_texCoord, t0_p0, t0_p1, t0_p2) || pointInTriangle(v_texCoord, t1_p0, t1_p1, t1_p2) || pointInTriangle(v_texCoord, t2_p0, t2_p1, t2_p2) || pointInTriangle(v_texCoord, t3_p0, t3_p1, t3_p2) || pointInTriangle(v_texCoord, t4_p0, t4_p1, t4_p2) || pointInTriangle(v_texCoord, t5_p0, t5_p1, t5_p2) || pointInTriangle(v_texCoord, t6_p0, t6_p1, t6_p2) || pointInTriangle(v_texCoord, t7_p0, t7_p1, t7_p2)){\n        gl_FragColor = color_a;\n    } else {\n        gl_FragColor = color_b;\n    }\n}\n";
        },
        "./src/Definitions/starWipe/starWipe.js":
        /*!**********************************************!*\
          !*** ./src/Definitions/starWipe/starWipe.js ***!
          \**********************************************/

        /*! no static exports found */
        function srcDefinitionsStarWipeStarWipeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./starWipe.vert */
          "./src/Definitions/starWipe/starWipe.vert"), n(
          /*! ./starWipe.frag */
          "./src/Definitions/starWipe/starWipe.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r17) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r17);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Star Wipe Fade",
              description: "A classic star wipe transistion. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/starWipe/starWipe.vert":
        /*!************************************************!*\
          !*** ./src/Definitions/starWipe/starWipe.vert ***!
          \************************************************/

        /*! no static exports found */
        function srcDefinitionsStarWipeStarWipeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/staticDissolve/staticDissolve.frag":
        /*!************************************************************!*\
          !*** ./src/Definitions/staticDissolve/staticDissolve.frag ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsStaticDissolveStaticDissolveFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nuniform float currentTime;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nfloat rand(vec2 co, float currentTime){\n    return fract(sin(dot(co.xy,vec2(12.9898,78.233))+currentTime) * 43758.5453);\n}\nvoid main(){\n    vec4 color_a = texture2D(u_image_a, v_texCoord);\n    vec4 color_b = texture2D(u_image_b, v_texCoord);\n    if (clamp(rand(v_texCoord, currentTime),  0.01, 1.001) > mix){\n        gl_FragColor = color_a;\n    } else {\n        gl_FragColor = color_b;\n    }\n}\n";
        },
        "./src/Definitions/staticDissolve/staticDissolve.js":
        /*!**********************************************************!*\
          !*** ./src/Definitions/staticDissolve/staticDissolve.js ***!
          \**********************************************************/

        /*! no static exports found */
        function srcDefinitionsStaticDissolveStaticDissolveJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./staticDissolve.vert */
          "./src/Definitions/staticDissolve/staticDissolve.vert"), n(
          /*! ./staticDissolve.frag */
          "./src/Definitions/staticDissolve/staticDissolve.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r18) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r18);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Static Dissolve",
              description: "A static dissolve effect. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/staticDissolve/staticDissolve.vert":
        /*!************************************************************!*\
          !*** ./src/Definitions/staticDissolve/staticDissolve.vert ***!
          \************************************************************/

        /*! no static exports found */
        function srcDefinitionsStaticDissolveStaticDissolveVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/staticEffect/staticEffect.frag":
        /*!********************************************************!*\
          !*** ./src/Definitions/staticEffect/staticEffect.frag ***!
          \********************************************************/

        /*! no static exports found */
        function srcDefinitionsStaticEffectStaticEffectFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nuniform float currentTime;\nuniform float amount;\nvarying vec2 v_texCoord;\nuniform vec3 weight;\nfloat rand(vec2 co, float currentTime){\n    return fract(sin(dot(co.xy,vec2(12.9898,78.233))+currentTime) * 43758.5453);\n}\nvoid main(){\n    vec4 color = texture2D(u_image, v_texCoord);\n    color[0] = color[0] + (2.0*(clamp(rand(v_texCoord, currentTime),  0.01, 1.001)-0.5)) * weight[0] * amount;\n    color[1] = color[1] + (2.0*(clamp(rand(v_texCoord, currentTime),  0.01, 1.001)-0.5)) * weight[1] * amount;\n    color[2] = color[2] + (2.0*(clamp(rand(v_texCoord, currentTime),  0.01, 1.001)-0.5)) * weight[2] *amount;\n    gl_FragColor = color;\n}\n";
        },
        "./src/Definitions/staticEffect/staticEffect.js":
        /*!******************************************************!*\
          !*** ./src/Definitions/staticEffect/staticEffect.js ***!
          \******************************************************/

        /*! no static exports found */
        function srcDefinitionsStaticEffectStaticEffectJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./staticEffect.vert */
          "./src/Definitions/staticEffect/staticEffect.vert"), n(
          /*! ./staticEffect.frag */
          "./src/Definitions/staticEffect/staticEffect.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r19) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r19);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Static",
              description: "A static effect to add pseudo random noise to a video",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                weight: {
                  type: "uniform",
                  value: [1, 1, 1]
                },
                amount: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/staticEffect/staticEffect.vert":
        /*!********************************************************!*\
          !*** ./src/Definitions/staticEffect/staticEffect.vert ***!
          \********************************************************/

        /*! no static exports found */
        function srcDefinitionsStaticEffectStaticEffectVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/toColorAndBackFade/toColorAndBackFade.frag":
        /*!********************************************************************!*\
          !*** ./src/Definitions/toColorAndBackFade/toColorAndBackFade.frag ***!
          \********************************************************************/

        /*! no static exports found */
        function srcDefinitionsToColorAndBackFadeToColorAndBackFadeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nuniform vec4 color;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color_a = texture2D(u_image_a, v_texCoord);\n    vec4 color_b = texture2D(u_image_b, v_texCoord);\n    float mix_amount = (mix *2.0) - 1.0;\n    if(mix_amount < 0.0){\n        gl_FragColor = abs(mix_amount) * color_a + (1.0 - abs(mix_amount)) * color;\n    } else {\n        gl_FragColor = mix_amount * color_b + (1.0 - mix_amount) * color;\n    }\n}\n";
        },
        "./src/Definitions/toColorAndBackFade/toColorAndBackFade.js":
        /*!******************************************************************!*\
          !*** ./src/Definitions/toColorAndBackFade/toColorAndBackFade.js ***!
          \******************************************************************/

        /*! no static exports found */
        function srcDefinitionsToColorAndBackFadeToColorAndBackFadeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./toColorAndBackFade.vert */
          "./src/Definitions/toColorAndBackFade/toColorAndBackFade.vert"), n(
          /*! ./toColorAndBackFade.frag */
          "./src/Definitions/toColorAndBackFade/toColorAndBackFade.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r20) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r20);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "To Color And Back Fade",
              description: "A fade to black and back effect. Setting mix to 0.5 is a fully solid color frame. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                },
                color: {
                  type: "uniform",
                  value: [0, 0, 0, 0]
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/toColorAndBackFade/toColorAndBackFade.vert":
        /*!********************************************************************!*\
          !*** ./src/Definitions/toColorAndBackFade/toColorAndBackFade.vert ***!
          \********************************************************************/

        /*! no static exports found */
        function srcDefinitionsToColorAndBackFadeToColorAndBackFadeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/Definitions/verticalBlur/verticalBlur.frag":
        /*!********************************************************!*\
          !*** ./src/Definitions/verticalBlur/verticalBlur.frag ***!
          \********************************************************/

        /*! no static exports found */
        function srcDefinitionsVerticalBlurVerticalBlurFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec2 v_blurTexCoords[14];\nvoid main(){\n    gl_FragColor = vec4(0.0);\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 0])*0.0044299121055113265;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 1])*0.00895781211794;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 2])*0.0215963866053;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 3])*0.0443683338718;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 4])*0.0776744219933;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 5])*0.115876621105;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 6])*0.147308056121;\n    gl_FragColor += texture2D(u_image, v_texCoord         )*0.159576912161;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 7])*0.147308056121;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 8])*0.115876621105;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[ 9])*0.0776744219933;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[10])*0.0443683338718;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[11])*0.0215963866053;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[12])*0.00895781211794;\n    gl_FragColor += texture2D(u_image, v_blurTexCoords[13])*0.0044299121055113265;\n}\n";
        },
        "./src/Definitions/verticalBlur/verticalBlur.js":
        /*!******************************************************!*\
          !*** ./src/Definitions/verticalBlur/verticalBlur.js ***!
          \******************************************************/

        /*! no static exports found */
        function srcDefinitionsVerticalBlurVerticalBlurJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./verticalBlur.vert */
          "./src/Definitions/verticalBlur/verticalBlur.vert"), n(
          /*! ./verticalBlur.frag */
          "./src/Definitions/verticalBlur/verticalBlur.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r21) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r21);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "Vertical Blur",
              description: "A vertical blur effect. Adpated from http://xissburg.com/faster-gaussian-blur-in-glsl/",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                blurAmount: {
                  type: "uniform",
                  value: 1
                }
              },
              inputs: ["u_image"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/verticalBlur/verticalBlur.vert":
        /*!********************************************************!*\
          !*** ./src/Definitions/verticalBlur/verticalBlur.vert ***!
          \********************************************************/

        /*! no static exports found */
        function srcDefinitionsVerticalBlurVerticalBlurVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nuniform float blurAmount;\nvarying vec2 v_blurTexCoords[14];\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n    v_blurTexCoords[ 0] = v_texCoord + vec2(0.0,-0.028 * blurAmount);\n    v_blurTexCoords[ 1] = v_texCoord + vec2(0.0,-0.024 * blurAmount);\n    v_blurTexCoords[ 2] = v_texCoord + vec2(0.0,-0.020 * blurAmount);\n    v_blurTexCoords[ 3] = v_texCoord + vec2(0.0,-0.016 * blurAmount);\n    v_blurTexCoords[ 4] = v_texCoord + vec2(0.0,-0.012 * blurAmount);\n    v_blurTexCoords[ 5] = v_texCoord + vec2(0.0,-0.008 * blurAmount);\n    v_blurTexCoords[ 6] = v_texCoord + vec2(0.0,-0.004 * blurAmount);\n    v_blurTexCoords[ 7] = v_texCoord + vec2(0.0, 0.004 * blurAmount);\n    v_blurTexCoords[ 8] = v_texCoord + vec2(0.0, 0.008 * blurAmount);\n    v_blurTexCoords[ 9] = v_texCoord + vec2(0.0, 0.012 * blurAmount);\n    v_blurTexCoords[10] = v_texCoord + vec2(0.0, 0.016 * blurAmount);\n    v_blurTexCoords[11] = v_texCoord + vec2(0.0, 0.020 * blurAmount);\n    v_blurTexCoords[12] = v_texCoord + vec2(0.0, 0.024 * blurAmount);\n    v_blurTexCoords[13] = v_texCoord + vec2(0.0, 0.028 * blurAmount);\n}\n";
        },
        "./src/Definitions/verticalWipe/verticalWipe.frag":
        /*!********************************************************!*\
          !*** ./src/Definitions/verticalWipe/verticalWipe.frag ***!
          \********************************************************/

        /*! no static exports found */
        function srcDefinitionsVerticalWipeVerticalWipeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image_a;\nuniform sampler2D u_image_b;\nuniform float mix;\nvarying vec2 v_texCoord;\nvarying float v_mix;\nvoid main(){\n    vec4 color_a = texture2D(u_image_a, v_texCoord);\n    vec4 color_b = texture2D(u_image_b, v_texCoord);\n    if (v_texCoord[1] > mix){\n        gl_FragColor = color_a;\n    } else {\n        gl_FragColor = color_b;\n    }\n}\n";
        },
        "./src/Definitions/verticalWipe/verticalWipe.js":
        /*!******************************************************!*\
          !*** ./src/Definitions/verticalWipe/verticalWipe.js ***!
          \******************************************************/

        /*! no static exports found */
        function srcDefinitionsVerticalWipeVerticalWipeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./verticalWipe.vert */
          "./src/Definitions/verticalWipe/verticalWipe.vert"), n(
          /*! ./verticalWipe.frag */
          "./src/Definitions/verticalWipe/verticalWipe.frag")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r22) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var o = a(n),
                i = a(_r22);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var s = {
              title: "vertical Wipe",
              description: "A vertical wipe effect. Typically used as a transistion.",
              vertexShader: o.default,
              fragmentShader: i.default,
              properties: {
                mix: {
                  type: "uniform",
                  value: 0
                }
              },
              inputs: ["u_image_a", "u_image_b"]
            };
            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/Definitions/verticalWipe/verticalWipe.vert":
        /*!********************************************************!*\
          !*** ./src/Definitions/verticalWipe/verticalWipe.vert ***!
          \********************************************************/

        /*! no static exports found */
        function srcDefinitionsVerticalWipeVerticalWipeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/DestinationNode/destinationnode.frag":
        /*!**************************************************!*\
          !*** ./src/DestinationNode/destinationnode.frag ***!
          \**************************************************/

        /*! no static exports found */
        function srcDestinationNodeDestinationnodeFrag(e, t) {
          e.exports = "precision mediump float;\nuniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying float v_progress;\nvoid main(){\n    gl_FragColor = texture2D(u_image, v_texCoord);\n}\n";
        },
        "./src/DestinationNode/destinationnode.js":
        /*!************************************************!*\
          !*** ./src/DestinationNode/destinationnode.js ***!
          \************************************************/

        /*! no static exports found */
        function srcDestinationNodeDestinationnodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ../ProcessingNodes/processingnode */
          "./src/ProcessingNodes/processingnode.js"), n(
          /*! ./destinationnode.frag */
          "./src/DestinationNode/destinationnode.frag"), n(
          /*! ./destinationnode.vert */
          "./src/DestinationNode/destinationnode.vert")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r23) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.DESTINATIONTYPE = void 0;
            var o = s(t),
                i = s(n),
                a = s(_r23);

            function s(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var u = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                c = "DestinationNode",
                l = function (e) {
              function t(e, n) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);

                var r = {
                  fragmentShader: i.default,
                  vertexShader: a.default,
                  properties: {},
                  inputs: ["u_image"]
                },
                    o = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n, r, r.inputs, !1));

                return o._displayName = c, o;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), u(t, [{
                key: "_render",
                value: function value() {
                  var e = this,
                      n = this._gl;
                  n.bindFramebuffer(n.FRAMEBUFFER, null), n.blendFunc(n.SRC_ALPHA, n.ONE_MINUS_SRC_ALPHA), n.enable(n.BLEND), n.clearColor(0, 0, 0, 0), n.clear(n.COLOR_BUFFER_BIT), this.inputs.forEach(function (r) {
                    (function e(t, n, r) {
                      null === t && (t = Function.prototype);
                      var o = Object.getOwnPropertyDescriptor(t, n);

                      if (void 0 === o) {
                        var i = Object.getPrototypeOf(t);
                        return null === i ? void 0 : e(i, n, r);
                      }

                      if ("value" in o) return o.value;
                      var a = o.get;
                      return void 0 !== a ? a.call(r) : void 0;
                    })(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_render", e).call(e);
                    var o = r._texture,
                        i = !0,
                        a = !1,
                        s = void 0;

                    try {
                      for (var u, c = e._shaderInputsTextureUnitMapping[Symbol.iterator](); !(i = (u = c.next()).done); i = !0) {
                        var l = u.value;
                        n.activeTexture(l.textureUnit), n.uniform1i(l.location, l.textureUnitIndex), n.bindTexture(n.TEXTURE_2D, o);
                      }
                    } catch (e) {
                      a = !0, s = e;
                    } finally {
                      try {
                        !i && c.return && c.return();
                      } finally {
                        if (a) throw s;
                      }
                    }

                    n.drawArrays(n.TRIANGLES, 0, 6);
                  });
                }
              }]), t;
            }(o.default);

            e.DESTINATIONTYPE = c, e.default = l;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/DestinationNode/destinationnode.vert":
        /*!**************************************************!*\
          !*** ./src/DestinationNode/destinationnode.vert ***!
          \**************************************************/

        /*! no static exports found */
        function srcDestinationNodeDestinationnodeVert(e, t) {
          e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nvarying vec2 v_texCoord;\nvoid main() {\n    gl_Position = vec4(vec2(2.0,2.0)*a_position-vec2(1.0, 1.0), 0.0, 1.0);\n    v_texCoord = a_texCoord;\n}\n";
        },
        "./src/ProcessingNodes/compositingnode.js":
        /*!************************************************!*\
          !*** ./src/ProcessingNodes/compositingnode.js ***!
          \************************************************/

        /*! no static exports found */
        function srcProcessingNodesCompositingnodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./processingnode */
          "./src/ProcessingNodes/processingnode.js"), n(
          /*! ../utils.js */
          "./src/utils.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.COMPOSITINGTYPE = void 0;

            var r,
                o = (r = t) && r.__esModule ? r : {
              default: r
            },
                i = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                a = "CompositingNode",
                s = function (e) {
              function t(e, r, o) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);
                var i = (0, n.createElementTexture)(e);
                e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));

                var s = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, r, o, o.inputs, !1));

                return s._placeholderTexture = i, s._displayName = a, s;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), i(t, [{
                key: "_render",
                value: function value() {
                  var e = this,
                      n = this._gl;
                  n.bindFramebuffer(n.FRAMEBUFFER, this._framebuffer), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, this._texture, 0), n.clearColor(0, 0, 0, 0), n.clear(n.COLOR_BUFFER_BIT), n.blendFuncSeparate(n.SRC_ALPHA, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA), this.inputs.forEach(function (r) {
                    if (void 0 !== r) {
                      (function e(t, n, r) {
                        null === t && (t = Function.prototype);
                        var o = Object.getOwnPropertyDescriptor(t, n);

                        if (void 0 === o) {
                          var i = Object.getPrototypeOf(t);
                          return null === i ? void 0 : e(i, n, r);
                        }

                        if ("value" in o) return o.value;
                        var a = o.get;
                        return void 0 !== a ? a.call(r) : void 0;
                      })(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_render", e).call(e);
                      var o = r._texture,
                          i = !0,
                          a = !1,
                          s = void 0;

                      try {
                        for (var u, c = e._shaderInputsTextureUnitMapping[Symbol.iterator](); !(i = (u = c.next()).done); i = !0) {
                          var l = u.value;
                          n.activeTexture(l.textureUnit), n.uniform1i(l.location, l.textureUnitIndex), n.bindTexture(n.TEXTURE_2D, o);
                        }
                      } catch (e) {
                        a = !0, s = e;
                      } finally {
                        try {
                          !i && c.return && c.return();
                        } finally {
                          if (a) throw s;
                        }
                      }

                      n.drawArrays(n.TRIANGLES, 0, 6);
                    }
                  }), n.bindFramebuffer(n.FRAMEBUFFER, null);
                }
              }]), t;
            }(o.default);

            e.COMPOSITINGTYPE = a, e.default = s;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/ProcessingNodes/effectnode.js":
        /*!*******************************************!*\
          !*** ./src/ProcessingNodes/effectnode.js ***!
          \*******************************************/

        /*! no static exports found */
        function srcProcessingNodesEffectnodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./processingnode */
          "./src/ProcessingNodes/processingnode.js"), n(
          /*! ../utils.js */
          "./src/utils.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.EFFECTYPE = void 0;

            var r,
                o = (r = t) && r.__esModule ? r : {
              default: r
            },
                i = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                a = "EffectNode",
                s = function (e) {
              function t(e, r, o) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);
                var i = (0, n.createElementTexture)(e);
                e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));

                var s = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, r, o, o.inputs, !0));

                return s._placeholderTexture = i, s._displayName = a, s;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), i(t, [{
                key: "_render",
                value: function value() {
                  var e = this._gl;
                  e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, this._texture, 0), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), e.blendFunc(e.ONE, e.ZERO), function e(t, n, r) {
                    null === t && (t = Function.prototype);
                    var o = Object.getOwnPropertyDescriptor(t, n);

                    if (void 0 === o) {
                      var i = Object.getPrototypeOf(t);
                      return null === i ? void 0 : e(i, n, r);
                    }

                    if ("value" in o) return o.value;
                    var a = o.get;
                    return void 0 !== a ? a.call(r) : void 0;
                  }(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_render", this).call(this);

                  for (var n = this._renderGraph.getInputsForNode(this), r = 0; r < this._shaderInputsTextureUnitMapping.length; r++) {
                    var o = this._placeholderTexture,
                        i = this._shaderInputsTextureUnitMapping[r].textureUnit;
                    r < n.length && void 0 !== n[r] && (o = n[r]._texture), e.activeTexture(i), e.uniform1i(this._shaderInputsTextureUnitMapping[r].location, this._shaderInputsTextureUnitMapping[r].textureUnitIndex), e.bindTexture(e.TEXTURE_2D, o);
                  }

                  e.drawArrays(e.TRIANGLES, 0, 6), e.bindFramebuffer(e.FRAMEBUFFER, null);
                }
              }]), t;
            }(o.default);

            e.EFFECTYPE = a, e.default = s;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/ProcessingNodes/processingnode.js":
        /*!***********************************************!*\
          !*** ./src/ProcessingNodes/processingnode.js ***!
          \***********************************************/

        /*! no static exports found */
        function srcProcessingNodesProcessingnodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ../graphnode */
          "./src/graphnode.js"), n(
          /*! ../utils.js */
          "./src/utils.js"), n(
          /*! ../exceptions.js */
          "./src/exceptions.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r24) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PROCESSINGTYPE = void 0;

            var o,
                i = (o = t) && o.__esModule ? o : {
              default: o
            },
                a = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                s = "ProcessingNode",
                u = function (e) {
              function t(e, o, i, a, u) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);

                var c = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, o, a, u));

                for (var l in c._vertexShader = (0, n.compileShader)(e, i.vertexShader, e.VERTEX_SHADER), c._fragmentShader = (0, n.compileShader)(e, i.fragmentShader, e.FRAGMENT_SHADER), c._definition = i, c._properties = {}, i.properties) {
                  var f = i.properties[l].value;
                  "[object Array]" === Object.prototype.toString.call(f) && (f = i.properties[l].value.slice());
                  var d = i.properties[l].type;
                  c._properties[l] = {
                    type: d,
                    value: f
                  };
                }

                c._shaderInputsTextureUnitMapping = [], c._maxTextureUnits = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), c._boundTextureUnits = 0, c._texture = (0, n.createElementTexture)(e), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.canvas.width, e.canvas.height, 0, e.RGBA, e.UNSIGNED_BYTE, null), c._program = (0, n.createShaderProgram)(e, c._vertexShader, c._fragmentShader), c._framebuffer = e.createFramebuffer(), e.bindFramebuffer(e.FRAMEBUFFER, c._framebuffer), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, c._texture, 0), e.bindFramebuffer(e.FRAMEBUFFER, null);

                var p = function p(e) {
                  Object.defineProperty(c, e, {
                    get: function get() {
                      return this._properties[e].value;
                    },
                    set: function set(t) {
                      this._properties[e].value = t;
                    }
                  });
                };

                for (var v in c._properties) {
                  p(v);
                }

                for (var _ in c._properties) {
                  if (c._properties[_].value instanceof Image && (c._properties[_].texture = (0, n.createElementTexture)(e), c._properties[_].textureUnit = e.TEXTURE0 + c._boundTextureUnits, c._properties[_].textureUnitIndex = c._boundTextureUnits, c._boundTextureUnits += 1, c._boundTextureUnits > c._maxTextureUnits)) throw new _r24.RenderException("Trying to bind more than available textures units to shader");
                }

                var h = !0,
                    m = !1,
                    y = void 0;

                try {
                  for (var g, b = i.inputs[Symbol.iterator](); !(h = (g = b.next()).done); h = !0) {
                    var x = g.value;
                    if (c._shaderInputsTextureUnitMapping.push({
                      name: x,
                      textureUnit: e.TEXTURE0 + c._boundTextureUnits,
                      textureUnitIndex: c._boundTextureUnits,
                      location: e.getUniformLocation(c._program, x)
                    }), c._boundTextureUnits += 1, c._boundTextureUnits > c._maxTextureUnits) throw new _r24.RenderException("Trying to bind more than available textures units to shader");
                  }
                } catch (e) {
                  m = !0, y = e;
                } finally {
                  try {
                    !h && b.return && b.return();
                  } finally {
                    if (m) throw y;
                  }
                }

                for (var T in c._properties) {
                  "uniform" === c._properties[T].type && (c._properties[T].location = c._gl.getUniformLocation(c._program, T));
                }

                c._currentTimeLocation = c._gl.getUniformLocation(c._program, "currentTime"), c._currentTime = 0;
                var E = e.getAttribLocation(c._program, "a_position"),
                    C = e.createBuffer();
                e.bindBuffer(e.ARRAY_BUFFER, C), e.enableVertexAttribArray(E), e.vertexAttribPointer(E, 2, e.FLOAT, !1, 0, 0), e.bufferData(e.ARRAY_BUFFER, new Float32Array([1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0]), e.STATIC_DRAW);
                var O = e.getAttribLocation(c._program, "a_texCoord");
                return e.enableVertexAttribArray(O), e.vertexAttribPointer(O, 2, e.FLOAT, !1, 0, 0), c._displayName = s, c;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), a(t, [{
                key: "setProperty",
                value: function value(e, t) {
                  this._properties[e].value = t;
                }
              }, {
                key: "getProperty",
                value: function value(e) {
                  return this._properties[e].value;
                }
              }, {
                key: "destroy",
                value: function value() {
                  for (var e in function e(t, n, r) {
                    null === t && (t = Function.prototype);
                    var o = Object.getOwnPropertyDescriptor(t, n);

                    if (void 0 === o) {
                      var i = Object.getPrototypeOf(t);
                      return null === i ? void 0 : e(i, n, r);
                    }

                    if ("value" in o) return o.value;
                    var a = o.get;
                    return void 0 !== a ? a.call(r) : void 0;
                  }(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "destroy", this).call(this), this._properties) {
                    this._properties[e].value instanceof Image && (this._gl.deleteTexture(this._properties[e].texture), this._texture = void 0);
                  }

                  this._gl.deleteTexture(this._texture), this._texture = void 0, this._gl.detachShader(this._program, this._vertexShader), this._gl.detachShader(this._program, this._fragmentShader), this._gl.deleteShader(this._vertexShader), this._gl.deleteShader(this._fragmentShader), this._gl.deleteProgram(this._program), this._gl.deleteFramebuffer(this._framebuffer);
                }
              }, {
                key: "_update",
                value: function value(e) {
                  this._currentTime = e;
                }
              }, {
                key: "_seek",
                value: function value(e) {
                  this._currentTime = e;
                }
              }, {
                key: "_render",
                value: function value() {
                  this._rendered = !0;
                  var e = this._gl;

                  for (var t in e.viewport(0, 0, e.canvas.width, e.canvas.height), e.useProgram(this._program), e.uniform1f(this._currentTimeLocation, parseFloat(this._currentTime)), this._properties) {
                    var r = this._properties[t].value,
                        o = this._properties[t].type,
                        i = this._properties[t].location;
                    if ("uniform" === o) if ("number" == typeof r) e.uniform1f(i, r);else if ("[object Array]" === Object.prototype.toString.call(r)) 1 === r.length ? e.uniform1fv(i, r) : 2 === r.length ? e.uniform2fv(i, r) : 3 === r.length ? e.uniform3fv(i, r) : 4 === r.length ? e.uniform4fv(i, r) : console.debug("Shader parameter", t, "is too long an array:", r);else if (r instanceof Image) {
                      var a = this._properties[t].texture,
                          s = this._properties[t].textureUnit,
                          u = this._properties[t].textureUnit;
                      (0, n.updateTexture)(e, a, r), e.activeTexture(s), e.uniform1i(i, u), e.bindTexture(e.TEXTURE_2D, a);
                    }
                  }
                }
              }]), t;
            }(i.default);

            e.PROCESSINGTYPE = s, e.default = u;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/ProcessingNodes/transitionnode.js":
        /*!***********************************************!*\
          !*** ./src/ProcessingNodes/transitionnode.js ***!
          \***********************************************/

        /*! no static exports found */
        function srcProcessingNodesTransitionnodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./effectnode */
          "./src/ProcessingNodes/effectnode.js")], void 0 === (i = "function" == typeof (r = function r(e, t) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TRANSITIONTYPE = void 0;

            var n,
                r = (n = t) && n.__esModule ? n : {
              default: n
            },
                o = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                i = "TransitionNode",
                a = function (e) {
              function t(e, n, r) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);

                var o = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n, r));

                for (var a in o._transitions = {}, o._initialPropertyValues = {}, o._properties) {
                  o._initialPropertyValues[a] = o._properties[a].value;
                }

                return o._displayName = i, o;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), o(t, [{
                key: "_doesTransitionFitOnTimeline",
                value: function value(e) {
                  if (void 0 === this._transitions[e.property]) return !0;
                  var t = !0,
                      n = !1,
                      r = void 0;

                  try {
                    for (var o, i = this._transitions[e.property][Symbol.iterator](); !(t = (o = i.next()).done); t = !0) {
                      var a = o.value;
                      if (e.start > a.start && e.start < a.end) return !1;
                      if (e.end > a.start && e.end < a.end) return !1;
                      if (a.start > e.start && a.start < e.end) return !1;
                      if (a.end > e.start && a.end < e.end) return !1;
                    }
                  } catch (e) {
                    n = !0, r = e;
                  } finally {
                    try {
                      !t && i.return && i.return();
                    } finally {
                      if (n) throw r;
                    }
                  }

                  return !0;
                }
              }, {
                key: "_insertTransitionInTimeline",
                value: function value(e) {
                  void 0 === this._transitions[e.property] && (this._transitions[e.property] = []), this._transitions[e.property].push(e), this._transitions[e.property].sort(function (e, t) {
                    return e.start - t.start;
                  });
                }
              }, {
                key: "transition",
                value: function value(e, t, n, r) {
                  var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "mix",
                      i = {
                    start: e + this._currentTime,
                    end: t + this._currentTime,
                    current: n,
                    target: r,
                    property: o
                  };
                  return !!this._doesTransitionFitOnTimeline(i) && (this._insertTransitionInTimeline(i), !0);
                }
              }, {
                key: "transitionAt",
                value: function value(e, t, n, r) {
                  var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "mix",
                      i = {
                    start: e,
                    end: t,
                    current: n,
                    target: r,
                    property: o
                  };
                  return !!this._doesTransitionFitOnTimeline(i) && (this._insertTransitionInTimeline(i), !0);
                }
              }, {
                key: "clearTransitions",
                value: function value(e) {
                  void 0 === e ? this._transitions = {} : this._transitions[e] = [];
                }
              }, {
                key: "clearTransition",
                value: function value(e, t) {
                  for (var n = void 0, r = 0; r < this._transitions[e].length; r++) {
                    var o = this._transitions[e][r];
                    t > o.start && t < o.end && (n = r);
                  }

                  return void 0 !== n && (this._transitions[e].splice(n, 1), !0);
                }
              }, {
                key: "_update",
                value: function value(e) {
                  for (var n in function e(t, n, r) {
                    null === t && (t = Function.prototype);
                    var o = Object.getOwnPropertyDescriptor(t, n);

                    if (void 0 === o) {
                      var i = Object.getPrototypeOf(t);
                      return null === i ? void 0 : e(i, n, r);
                    }

                    if ("value" in o) return o.value;
                    var a = o.get;
                    return void 0 !== a ? a.call(r) : void 0;
                  }(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_update", this).call(this, e), this._transitions) {
                    var r = this[n];
                    this._transitions[n].length > 0 && (r = this._transitions[n][0].current);

                    for (var o = !1, i = 0; i < this._transitions[n].length; i++) {
                      var a = this._transitions[n][i];
                      if (e > a.end) r = a.target;else if (e > a.start && e < a.end) {
                        var s = a.target - a.current,
                            u = (this._currentTime - a.start) / (a.end - a.start);
                        o = !0, this[n] = a.current + s * u;
                        break;
                      }
                    }

                    o || (this[n] = r);
                  }
                }
              }]), t;
            }(r.default);

            e.TRANSITIONTYPE = i, e.default = a;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/audionode.js":
        /*!**************************************!*\
          !*** ./src/SourceNodes/audionode.js ***!
          \**************************************/

        /*! no static exports found */
        function srcSourceNodesAudionodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./medianode */
          "./src/SourceNodes/medianode.js")], void 0 === (i = "function" == typeof (r = function r(e, t) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AUDIOTYPE = void 0;

            var n,
                r = (n = t) && n.__esModule ? n : {
              default: n
            },
                o = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                i = "AudioNode",
                a = function (e) {
              function t() {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);

                var e = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));

                return e._displayName = i, e._elementType = "audio", e;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), o(t, [{
                key: "_update",
                value: function value(e) {
                  (function e(t, n, r) {
                    null === t && (t = Function.prototype);
                    var o = Object.getOwnPropertyDescriptor(t, n);

                    if (void 0 === o) {
                      var i = Object.getPrototypeOf(t);
                      return null === i ? void 0 : e(i, n, r);
                    }

                    if ("value" in o) return o.value;
                    var a = o.get;
                    return void 0 !== a ? a.call(r) : void 0;
                  })(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_update", this).call(this, e, !1);
                }
              }]), t;
            }(r.default);

            e.AUDIOTYPE = i, e.default = a;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/canvasnode.js":
        /*!***************************************!*\
          !*** ./src/SourceNodes/canvasnode.js ***!
          \***************************************/

        /*! no static exports found */
        function srcSourceNodesCanvasnodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./sourcenode */
          "./src/SourceNodes/sourcenode.js")], void 0 === (i = "function" == typeof (r = function r(e, t) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.CANVASTYPE = void 0;

            var n,
                r = (n = t) && n.__esModule ? n : {
              default: n
            },
                o = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                i = function e(t, n, r) {
              null === t && (t = Function.prototype);
              var o = Object.getOwnPropertyDescriptor(t, n);

              if (void 0 === o) {
                var i = Object.getPrototypeOf(t);
                return null === i ? void 0 : e(i, n, r);
              }

              if ("value" in o) return o.value;
              var a = o.get;
              return void 0 !== a ? a.call(r) : void 0;
            },
                a = "CanvasNode",
                s = function (e) {
              function n(e, t, r, o) {
                var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 4;
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, n);

                var s = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t, r, o));

                return s._preloadTime = i, s._displayName = a, s;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(n, e), o(n, [{
                key: "_load",
                value: function value() {
                  i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_load", this).call(this), this._ready = !0, this._triggerCallbacks("loaded");
                }
              }, {
                key: "_unload",
                value: function value() {
                  i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_unload", this).call(this), this._ready = !1;
                }
              }, {
                key: "_seek",
                value: function value(e) {
                  i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_seek", this).call(this, e), this.state !== t.SOURCENODESTATE.playing && this.state !== t.SOURCENODESTATE.paused || (void 0 === this._element && this._load(), this._ready = !1), this._state !== t.SOURCENODESTATE.sequenced && this._state !== t.SOURCENODESTATE.ended || void 0 === this._element || this._unload();
                }
              }, {
                key: "_update",
                value: function value(e) {
                  return i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_update", this).call(this, e), this._startTime - this._currentTime <= this._preloadTime && this._state !== t.SOURCENODESTATE.waiting && this._state !== t.SOURCENODESTATE.ended && this._load(), this._state === t.SOURCENODESTATE.playing || this._state === t.SOURCENODESTATE.paused || (this._state === t.SOURCENODESTATE.ended && void 0 !== this._element ? (this._unload(), !1) : void 0);
                }
              }]), n;
            }(r.default);

            e.CANVASTYPE = a, e.default = s;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/imagenode.js":
        /*!**************************************!*\
          !*** ./src/SourceNodes/imagenode.js ***!
          \**************************************/

        /*! no static exports found */
        function srcSourceNodesImagenodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./sourcenode */
          "./src/SourceNodes/sourcenode.js")], void 0 === (i = "function" == typeof (r = function r(e, t) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.IMAGETYPE = void 0;

            var n,
                r = (n = t) && n.__esModule ? n : {
              default: n
            },
                o = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                i = function e(t, n, r) {
              null === t && (t = Function.prototype);
              var o = Object.getOwnPropertyDescriptor(t, n);

              if (void 0 === o) {
                var i = Object.getPrototypeOf(t);
                return null === i ? void 0 : e(i, n, r);
              }

              if ("value" in o) return o.value;
              var a = o.get;
              return void 0 !== a ? a.call(r) : void 0;
            },
                a = "CanvasNode",
                s = function (e) {
              function n(e, t, r, o) {
                var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 4,
                    s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, n);

                var u = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t, r, o));

                return u._preloadTime = i, u._attributes = s, u._textureUploaded = !1, u._displayName = a, u;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(n, e), o(n, [{
                key: "_load",
                value: function value() {
                  var e = this;

                  if (void 0 === this._image) {
                    if (this._isResponsibleForElementLifeCycle) for (var r in i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_load", this).call(this), this._image = new Image(), this._image.setAttribute("crossorigin", "anonymous"), this._image.onload = function () {
                      e._ready = !0, window.createImageBitmap ? window.createImageBitmap(e._image, {
                        imageOrientation: "flipY"
                      }).then(function (t) {
                        e._element = t, e._triggerCallbacks("loaded");
                      }) : (e._element = e._image, e._triggerCallbacks("loaded"));
                    }, this._image.src = this._elementURL, this._image.onerror = function () {
                      console.error("ImageNode failed to load. url:", e._elementURL);
                    }, this._attributes) {
                      this._image[r] = this._attributes[r];
                    }

                    this._image.onerror = function () {
                      console.debug("Error with element", e._image), e._state = t.SOURCENODESTATE.error, e._ready = !0, e._triggerCallbacks("error");
                    };
                  } else for (var o in this._attributes) {
                    this._image[o] = this._attributes[o];
                  }
                }
              }, {
                key: "_unload",
                value: function value() {
                  i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_unload", this).call(this), this._isResponsibleForElementLifeCycle && (void 0 !== this._image && (this._image.src = "", this._image.onerror = void 0, this._image = void 0, delete this._image), this._element instanceof window.ImageBitmap && this._element.close()), this._ready = !1;
                }
              }, {
                key: "_seek",
                value: function value(e) {
                  i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_seek", this).call(this, e), this.state !== t.SOURCENODESTATE.playing && this.state !== t.SOURCENODESTATE.paused || void 0 === this._image && this._load(), this._state !== t.SOURCENODESTATE.sequenced && this._state !== t.SOURCENODESTATE.ended || void 0 === this._element || this._unload();
                }
              }, {
                key: "_update",
                value: function value(e) {
                  return this._textureUploaded ? i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_update", this).call(this, e, !1) : i(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "_update", this).call(this, e), this._startTime - this._currentTime <= this._preloadTime && this._state !== t.SOURCENODESTATE.waiting && this._state !== t.SOURCENODESTATE.ended && this._load(), this._state === t.SOURCENODESTATE.playing || this._state === t.SOURCENODESTATE.paused || (this._state === t.SOURCENODESTATE.ended && void 0 !== this._image ? (this._unload(), !1) : void 0);
                }
              }, {
                key: "elementURL",
                get: function get() {
                  return this._elementURL;
                }
              }]), n;
            }(r.default);

            e.IMAGETYPE = a, e.default = s;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/medianode.js":
        /*!**************************************!*\
          !*** ./src/SourceNodes/medianode.js ***!
          \**************************************/

        /*! no static exports found */
        function srcSourceNodesMedianodeJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./sourcenode */
          "./src/SourceNodes/sourcenode.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r,
                o = (r = n) && r.__esModule ? r : {
              default: r
            },
                i = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                a = function e(t, n, r) {
              null === t && (t = Function.prototype);
              var o = Object.getOwnPropertyDescriptor(t, n);

              if (void 0 === o) {
                var i = Object.getPrototypeOf(t);
                return null === i ? void 0 : e(i, n, r);
              }

              if ("value" in o) return o.value;
              var a = o.get;
              return void 0 !== a ? a.call(r) : void 0;
            },
                s = function (e) {
              function t(e, n, r, o) {
                var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
                    a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
                    s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 4,
                    u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : void 0,
                    c = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : {};
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);

                var l = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n, r, o));

                return l._preloadTime = s, l._sourceOffset = a, l._globalPlaybackRate = i, l._mediaElementCache = u, l._playbackRate = 1, l._playbackRateUpdated = !0, l._attributes = Object.assign({
                  volume: 1
                }, c), l._loopElement = !1, l._isElementPlaying = !1, l._attributes.loop && (l._loopElement = l._attributes.loop), l;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), i(t, [{
                key: "_triggerLoad",
                value: function value() {
                  var e = this;

                  if (this._isResponsibleForElementLifeCycle && (this._mediaElementCache ? this._element = this._mediaElementCache.getElementAndLinkToNode(this) : (this._element = document.createElement(this._elementType), this._element.setAttribute("crossorigin", "anonymous"), this._element.setAttribute("webkit-playsinline", ""), this._element.setAttribute("playsinline", ""), this._playbackRateUpdated = !0), this._element.volume = this._attributes.volume, void 0 !== window.MediaStream && this._elementURL instanceof MediaStream ? this._element.srcObject = this._elementURL : this._element.src = this._elementURL), this._element) {
                    for (var t in this._attributes) {
                      this._element[t] = this._attributes[t];
                    }

                    var r = 0;
                    this._currentTime > this._startTime && (r = this._currentTime - this._startTime), this._element.currentTime = this._sourceOffset + r, this._element.onerror = function () {
                      void 0 !== e._element && (console.debug("Error with element", e._element), e._state = n.SOURCENODESTATE.error, e._ready = !0, e._triggerCallbacks("error"));
                    };
                  } else this._state = n.SOURCENODESTATE.error, this._ready = !0, this._triggerCallbacks("error");

                  this._loadTriggered = !0;
                }
              }, {
                key: "_load",
                value: function value() {
                  a(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_load", this).call(this), this._loadTriggered || this._triggerLoad(), void 0 !== this._element && (this._element.readyState > 3 && !this._element.seeking ? (!1 === this._loopElement && (this._stopTime !== 1 / 0 && null != this._stopTime || (this._stopTime = this._startTime + this._element.duration, this._triggerCallbacks("durationchange", this.duration))), !0 !== this._ready && (this._triggerCallbacks("loaded"), this._playbackRateUpdated = !0), this._ready = !0) : this._state !== n.SOURCENODESTATE.error && (this._ready = !1));
                }
              }, {
                key: "_unload",
                value: function value() {
                  if (a(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_unload", this).call(this), this._isResponsibleForElementLifeCycle && void 0 !== this._element) {
                    for (var e in this._element.removeAttribute("src"), this._element.srcObject = void 0, this._element.load(), this._attributes) {
                      this._element.removeAttribute(e);
                    }

                    this._mediaElementCache && this._mediaElementCache.unlinkNodeFromElement(this._element), this._element = void 0, this._mediaElementCache || delete this._element;
                  }

                  this._ready = !1, this._isElementPlaying = !1, this._loadTriggered = !1;
                }
              }, {
                key: "_seek",
                value: function value(e) {
                  if (a(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_seek", this).call(this, e), this.state === n.SOURCENODESTATE.playing || this.state === n.SOURCENODESTATE.paused) {
                    void 0 === this._element && this._load();
                    var r = this._currentTime - this._startTime + this._sourceOffset;
                    this._element.currentTime = r, this._ready = !1;
                  }

                  this._state !== n.SOURCENODESTATE.sequenced && this._state !== n.SOURCENODESTATE.ended || void 0 === this._element || this._unload();
                }
              }, {
                key: "_update",
                value: function value(e) {
                  var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                  return a(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "_update", this).call(this, e, r), void 0 !== this._element && this._element.ended && (this._state = n.SOURCENODESTATE.ended, this._triggerCallbacks("ended")), this._startTime - this._currentTime <= this._preloadTime && this._state !== n.SOURCENODESTATE.waiting && this._state !== n.SOURCENODESTATE.ended && this._load(), this._state === n.SOURCENODESTATE.playing ? (this._playbackRateUpdated && (this._element.playbackRate = this._globalPlaybackRate * this._playbackRate, this._playbackRateUpdated = !1), this._isElementPlaying || (this._element.play(), this._stretchPaused && this._element.pause(), this._isElementPlaying = !0), !0) : this._state === n.SOURCENODESTATE.paused ? (this._element.pause(), this._isElementPlaying = !1, !0) : this._state === n.SOURCENODESTATE.ended && void 0 !== this._element ? (this._element.pause(), this._isElementPlaying && this._unload(), !1) : void 0;
                }
              }, {
                key: "clearTimelineState",
                value: function value() {
                  a(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "clearTimelineState", this).call(this), void 0 !== this._element && (this._element.pause(), this._isElementPlaying = !1), this._unload();
                }
              }, {
                key: "destroy",
                value: function value() {
                  this._element && this._element.pause(), a(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "destroy", this).call(this);
                }
              }, {
                key: "playbackRate",
                set: function set(e) {
                  this._playbackRate = e, this._playbackRateUpdated = !0;
                },
                get: function get() {
                  return this._playbackRate;
                }
              }, {
                key: "stretchPaused",
                set: function set(e) {
                  !function e(t, n, r, o) {
                    var i = Object.getOwnPropertyDescriptor(t, n);

                    if (void 0 === i) {
                      var a = Object.getPrototypeOf(t);
                      null !== a && e(a, n, r, o);
                    } else if ("value" in i && i.writable) i.value = r;else {
                      var s = i.set;
                      void 0 !== s && s.call(o, r);
                    }

                    return r;
                  }(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "stretchPaused", e, this), this._element && (this._stretchPaused ? this._element.pause() : this._state === n.SOURCENODESTATE.playing && this._element.play());
                },
                get: function get() {
                  return this._stretchPaused;
                }
              }, {
                key: "elementURL",
                get: function get() {
                  return this._elementURL;
                }
              }, {
                key: "_buffering",
                get: function get() {
                  return !!this._element && this._element.readyState < HTMLMediaElement.HAVE_FUTURE_DATA;
                }
              }, {
                key: "volume",
                set: function set(e) {
                  this._attributes.volume = e, void 0 !== this._element && (this._element.volume = this._attributes.volume);
                }
              }]), t;
            }(o.default);

            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/nodes.js":
        /*!**********************************!*\
          !*** ./src/SourceNodes/nodes.js ***!
          \**********************************/

        /*! no static exports found */
        function srcSourceNodesNodesJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./audionode */
          "./src/SourceNodes/audionode.js"), n(
          /*! ./canvasnode */
          "./src/SourceNodes/canvasnode.js"), n(
          /*! ./imagenode */
          "./src/SourceNodes/imagenode.js"), n(
          /*! ./medianode */
          "./src/SourceNodes/medianode.js"), n(
          /*! ./sourcenode */
          "./src/SourceNodes/sourcenode.js"), n(
          /*! ./videonode */
          "./src/SourceNodes/videonode.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r25, o, i, a, s) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var u = v(n),
                c = v(_r25),
                l = v(o),
                f = v(i),
                d = v(a),
                p = v(s);

            function v(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var _ = {
              AudioNode: u.default,
              CanvasNode: c.default,
              ImageNode: l.default,
              MediaNode: f.default,
              SourceNode: d.default,
              VideoNode: p.default
            };
            t.default = _, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/sourcenode.js":
        /*!***************************************!*\
          !*** ./src/SourceNodes/sourcenode.js ***!
          \***************************************/

        /*! no static exports found */
        function srcSourceNodesSourcenodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ../utils.js */
          "./src/utils.js"), n(
          /*! ../graphnode */
          "./src/graphnode.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.SOURCETYPE = e.SOURCENODESTATE = void 0;

            var r,
                o = (r = n) && r.__esModule ? r : {
              default: r
            },
                i = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                a = {
              waiting: 0,
              sequenced: 1,
              playing: 2,
              paused: 3,
              ended: 4,
              error: 5
            },
                s = "SourceNode",
                u = function (e) {
              function n(e, r, o, i) {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, n);

                var u = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, r, o, [], !0));

                return u._element = void 0, u._elementURL = void 0, u._isResponsibleForElementLifeCycle = !0, "string" == typeof e || void 0 !== window.MediaStream && e instanceof MediaStream ? u._elementURL = e : (u._element = e, u._isResponsibleForElementLifeCycle = !1), u._state = a.waiting, u._currentTime = i, u._startTime = NaN, u._stopTime = 1 / 0, u._ready = !1, u._loadCalled = !1, u._stretchPaused = !1, u._texture = (0, t.createElementTexture)(r), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, 1, 1, 0, r.RGBA, r.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0])), u._callbacks = [], u._renderPaused = !1, u._displayName = s, u;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(n, e), i(n, [{
                key: "_load",
                value: function value() {
                  this._loadCalled || (this._triggerCallbacks("load"), this._loadCalled = !0);
                }
              }, {
                key: "_unload",
                value: function value() {
                  this._triggerCallbacks("destroy"), this._loadCalled = !1;
                }
              }, {
                key: "registerCallback",
                value: function value(e, t) {
                  this._callbacks.push({
                    type: e,
                    func: t
                  });
                }
              }, {
                key: "unregisterCallback",
                value: function value(e) {
                  var t = [],
                      n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = this._callbacks[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      var s = i.value;
                      void 0 === e ? t.push(s) : s.func === e && t.push(s);
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }

                  var u = !0,
                      c = !1,
                      l = void 0;

                  try {
                    for (var f, d = t[Symbol.iterator](); !(u = (f = d.next()).done); u = !0) {
                      var p = f.value,
                          v = this._callbacks.indexOf(p);

                      this._callbacks.splice(v, 1);
                    }
                  } catch (e) {
                    c = !0, l = e;
                  } finally {
                    try {
                      !u && d.return && d.return();
                    } finally {
                      if (c) throw l;
                    }
                  }
                }
              }, {
                key: "_triggerCallbacks",
                value: function value(e, t) {
                  var n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = this._callbacks[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      var s = i.value;
                      s.type === e && (void 0 !== t ? s.func(this, t) : s.func(this));
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }
                }
              }, {
                key: "start",
                value: function value(e) {
                  return this._state !== a.waiting ? (console.debug("SourceNode is has already been sequenced. Can't sequence twice."), !1) : (this._startTime = this._currentTime + e, this._state = a.sequenced, !0);
                }
              }, {
                key: "startAt",
                value: function value(e) {
                  return this._state !== a.waiting ? (console.debug("SourceNode is has already been sequenced. Can't sequence twice."), !1) : (this._startTime = e, this._state = a.sequenced, !0);
                }
              }, {
                key: "stop",
                value: function value(e) {
                  return this._state === a.ended ? (console.debug("SourceNode has already ended. Cannot call stop."), !1) : this._state === a.waiting ? (console.debug("SourceNode must have start called before stop is called"), !1) : this._currentTime + e <= this._startTime ? (console.debug("SourceNode must have a stop time after it's start time, not before."), !1) : (this._stopTime = this._currentTime + e, this._stretchPaused = !1, this._triggerCallbacks("durationchange", this.duration), !0);
                }
              }, {
                key: "stopAt",
                value: function value(e) {
                  return this._state === a.ended ? (console.debug("SourceNode has already ended. Cannot call stop."), !1) : this._state === a.waiting ? (console.debug("SourceNode must have start called before stop is called"), !1) : e <= this._startTime ? (console.debug("SourceNode must have a stop time after it's start time, not before."), !1) : (this._stopTime = e, this._stretchPaused = !1, this._triggerCallbacks("durationchange", this.duration), !0);
                }
              }, {
                key: "_seek",
                value: function value(e) {
                  this._renderPaused = !1, this._triggerCallbacks("seek", e), this._state !== a.waiting && (e < this._startTime && ((0, t.clearTexture)(this._gl, this._texture), this._state = a.sequenced), e >= this._startTime && this._state !== a.paused && (this._state = a.playing), e >= this._stopTime && ((0, t.clearTexture)(this._gl, this._texture), this._triggerCallbacks("ended"), this._state = a.ended), this._currentTime = e);
                }
              }, {
                key: "_pause",
                value: function value() {
                  (this._state === a.playing || 0 === this._currentTime && 0 === this._startTime) && (this._triggerCallbacks("pause"), this._state = a.paused, this._renderPaused = !1);
                }
              }, {
                key: "_play",
                value: function value() {
                  this._state === a.paused && (this._triggerCallbacks("play"), this._state = a.playing);
                }
              }, {
                key: "_isReady",
                value: function value() {
                  return !this._buffering && (this._state !== a.playing && this._state !== a.paused && this._state !== a.error || this._ready);
                }
              }, {
                key: "_update",
                value: function value(e) {
                  var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                  this._rendered = !0;
                  var r = e - this._currentTime;
                  return this._currentTime = e, this._state !== a.waiting && this._state !== a.ended && this._state !== a.error && (this._triggerCallbacks("render", e), e < this._startTime && ((0, t.clearTexture)(this._gl, this._texture), this._state = a.sequenced), e >= this._startTime && this._state !== a.paused && this._state !== a.error && (this._state !== a.playing && this._triggerCallbacks("play"), this._state = a.playing), e >= this._stopTime && ((0, t.clearTexture)(this._gl, this._texture), this._triggerCallbacks("ended"), this._state = a.ended), void 0 === this._element || !1 === this._ready || (this._renderPaused || this._state !== a.paused || (n && (0, t.updateTexture)(this._gl, this._texture, this._element), this._renderPaused = !0), this._state === a.playing && (n && (0, t.updateTexture)(this._gl, this._texture, this._element), this._stretchPaused && (this._stopTime += r)), !0));
                }
              }, {
                key: "clearTimelineState",
                value: function value() {
                  this._startTime = NaN, this._stopTime = 1 / 0, this._state = a.waiting;
                }
              }, {
                key: "destroy",
                value: function value() {
                  this._unload(), function e(t, n, r) {
                    null === t && (t = Function.prototype);
                    var o = Object.getOwnPropertyDescriptor(t, n);

                    if (void 0 === o) {
                      var i = Object.getPrototypeOf(t);
                      return null === i ? void 0 : e(i, n, r);
                    }

                    if ("value" in o) return o.value;
                    var a = o.get;
                    return void 0 !== a ? a.call(r) : void 0;
                  }(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "destroy", this).call(this), this.unregisterCallback(), delete this._element, this._elementURL = void 0, this._state = a.waiting, this._currentTime = 0, this._startTime = NaN, this._stopTime = 1 / 0, this._ready = !1, this._loadCalled = !1, this._gl.deleteTexture(this._texture), this._texture = void 0;
                }
              }, {
                key: "state",
                get: function get() {
                  return this._state;
                }
              }, {
                key: "element",
                get: function get() {
                  return this._element;
                }
              }, {
                key: "duration",
                get: function get() {
                  if (!isNaN(this._startTime)) return this._stopTime === 1 / 0 ? 1 / 0 : this._stopTime - this._startTime;
                }
              }, {
                key: "stretchPaused",
                set: function set(e) {
                  this._stretchPaused = e;
                },
                get: function get() {
                  return this._stretchPaused;
                }
              }, {
                key: "startTime",
                get: function get() {
                  return this._startTime;
                }
              }, {
                key: "stopTime",
                get: function get() {
                  return this._stopTime;
                }
              }]), n;
            }(o.default);

            e.SOURCENODESTATE = a, e.SOURCETYPE = s, e.default = u;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/SourceNodes/videonode.js":
        /*!**************************************!*\
          !*** ./src/SourceNodes/videonode.js ***!
          \**************************************/

        /*! no static exports found */
        function srcSourceNodesVideonodeJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./medianode */
          "./src/SourceNodes/medianode.js")], void 0 === (i = "function" == typeof (r = function r(e, t) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.VIDEOTYPE = void 0;

            var n,
                r = (n = t) && n.__esModule ? n : {
              default: n
            },
                o = "VideoNode",
                i = function (e) {
              function t() {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t);

                var e = function (e, t) {
                  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));

                return e._displayName = o, e._elementType = "video", e;
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
              }(t, e), t;
            }(r.default);

            e.VIDEOTYPE = o, e.default = i;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/exceptions.js":
        /*!***************************!*\
          !*** ./src/exceptions.js ***!
          \***************************/

        /*! no static exports found */
        function srcExceptionsJs(e, t, n) {
          var r, o, i;
          o = [t], void 0 === (i = "function" == typeof (r = function r(e) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.ConnectException = function (e) {
              this.message = e, this.name = "ConnectionException";
            }, e.RenderException = function (e) {
              this.message = e, this.name = "RenderException";
            };
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/graphnode.js":
        /*!**************************!*\
          !*** ./src/graphnode.js ***!
          \**************************/

        /*! no static exports found */
        function srcGraphnodeJs(e, t, n) {
          var r, o, i;
          o = [t], void 0 === (i = "function" == typeof (r = function r(e) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var t = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                n = "GraphNode",
                r = function () {
              function e(t, r, o) {
                var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this._renderGraph = r, this._limitConnections = i, this._inputNames = o, this._destroyed = !1, this._gl = t, this._renderGraph = r, this._rendered = !1, this._displayName = n;
              }

              return t(e, [{
                key: "connect",
                value: function value(e, t) {
                  return this._renderGraph.registerConnection(this, e, t);
                }
              }, {
                key: "disconnect",
                value: function value(e) {
                  var t = this;

                  if (void 0 === e) {
                    var n = this._renderGraph.getOutputsForNode(this);

                    return n.forEach(function (e) {
                      return t._renderGraph.unregisterConnection(t, e);
                    }), n.length > 0;
                  }

                  return this._renderGraph.unregisterConnection(this, e);
                }
              }, {
                key: "destroy",
                value: function value() {
                  this.disconnect();
                  var e = !0,
                      t = !1,
                      n = void 0;

                  try {
                    for (var r, o = this.inputs[Symbol.iterator](); !(e = (r = o.next()).done); e = !0) {
                      r.value.disconnect(this);
                    }
                  } catch (e) {
                    t = !0, n = e;
                  } finally {
                    try {
                      !e && o.return && o.return();
                    } finally {
                      if (t) throw n;
                    }
                  }

                  this._destroyed = !0;
                }
              }, {
                key: "displayName",
                get: function get() {
                  return this._displayName;
                }
              }, {
                key: "inputNames",
                get: function get() {
                  return this._inputNames.slice();
                }
              }, {
                key: "maximumConnections",
                get: function get() {
                  return !1 === this._limitConnections ? 1 / 0 : this._inputNames.length;
                }
              }, {
                key: "inputs",
                get: function get() {
                  var e = this._renderGraph.getInputsForNode(this);

                  return e = e.filter(function (e) {
                    return void 0 !== e;
                  });
                }
              }, {
                key: "outputs",
                get: function get() {
                  return this._renderGraph.getOutputsForNode(this);
                }
              }, {
                key: "destroyed",
                get: function get() {
                  return this._destroyed;
                }
              }]), e;
            }();

            e.GRAPHTYPE = n, e.default = r;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/rendergraph.js":
        /*!****************************!*\
          !*** ./src/rendergraph.js ***!
          \****************************/

        /*! no static exports found */
        function srcRendergraphJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./exceptions.js */
          "./src/exceptions.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                o = function () {
              function e() {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.connections = [];
              }

              return r(e, [{
                key: "getOutputsForNode",
                value: function value(e) {
                  var t = [];
                  return this.connections.forEach(function (n) {
                    n.source === e && t.push(n.destination);
                  }), t;
                }
              }, {
                key: "getNamedInputsForNode",
                value: function value(e) {
                  var t = [];
                  return this.connections.forEach(function (n) {
                    n.destination === e && "name" === n.type && t.push(n);
                  }), t;
                }
              }, {
                key: "getZIndexInputsForNode",
                value: function value(e) {
                  var t = [];
                  return this.connections.forEach(function (n) {
                    n.destination === e && "zIndex" === n.type && t.push(n);
                  }), t.sort(function (e, t) {
                    return e.zIndex - t.zIndex;
                  }), t;
                }
              }, {
                key: "getInputsForNode",
                value: function value(e) {
                  var t = e.inputNames,
                      n = [],
                      r = this.getNamedInputsForNode(e),
                      o = this.getZIndexInputsForNode(e);

                  if (!0 === e._limitConnections) {
                    for (var i = 0; i < t.length; i++) {
                      n[i] = void 0;
                    }

                    var a = !0,
                        s = !1,
                        u = void 0;

                    try {
                      for (var c, l = r[Symbol.iterator](); !(a = (c = l.next()).done); a = !0) {
                        var f = c.value;
                        n[t.indexOf(f.name)] = f.source;
                      }
                    } catch (e) {
                      s = !0, u = e;
                    } finally {
                      try {
                        !a && l.return && l.return();
                      } finally {
                        if (s) throw u;
                      }
                    }

                    for (var d = 0, p = 0; p < n.length; p++) {
                      void 0 === n[p] && void 0 !== o[d] && (n[p] = o[d].source, d += 1);
                    }
                  } else {
                    var v = !0,
                        _ = !1,
                        h = void 0;

                    try {
                      for (var m, y = r[Symbol.iterator](); !(v = (m = y.next()).done); v = !0) {
                        var g = m.value;
                        n.push(g.source);
                      }
                    } catch (e) {
                      _ = !0, h = e;
                    } finally {
                      try {
                        !v && y.return && y.return();
                      } finally {
                        if (_) throw h;
                      }
                    }

                    var b = !0,
                        x = !1,
                        T = void 0;

                    try {
                      for (var E, C = o[Symbol.iterator](); !(b = (E = C.next()).done); b = !0) {
                        var O = E.value;
                        n.push(O.source);
                      }
                    } catch (e) {
                      x = !0, T = e;
                    } finally {
                      try {
                        !b && C.return && C.return();
                      } finally {
                        if (x) throw T;
                      }
                    }
                  }

                  return n;
                }
              }, {
                key: "isInputAvailable",
                value: function value(e, t) {
                  if (-1 === e._inputNames.indexOf(t)) return !1;
                  var n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = this.connections[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      var s = i.value;
                      if ("name" === s.type && s.destination === e && s.name === t) return !1;
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }

                  return !0;
                }
              }, {
                key: "registerConnection",
                value: function value(e, t, r) {
                  if (t.inputs.length >= t.inputNames.length && !0 === t._limitConnections) throw new n.ConnectException("Node has reached max number of inputs, can't connect");
                  if (!1 === t._limitConnections && this.getInputsForNode(t).includes(e) && (console.debug("WARNING - node connected mutliple times, removing previous connection"), this.unregisterConnection(e, t)), "number" == typeof r) this.connections.push({
                    source: e,
                    type: "zIndex",
                    zIndex: r,
                    destination: t
                  });else if ("string" == typeof r && t._limitConnections) {
                    if (!this.isInputAvailable(t, r)) throw new n.ConnectException("Port " + r + " is already connected to");
                    this.connections.push({
                      source: e,
                      type: "name",
                      name: r,
                      destination: t
                    });
                  } else {
                    var o = this.getZIndexInputsForNode(t),
                        i = 0;
                    o.length > 0 && (i = o[o.length - 1].zIndex + 1), this.connections.push({
                      source: e,
                      type: "zIndex",
                      zIndex: i,
                      destination: t
                    });
                  }
                  return !0;
                }
              }, {
                key: "unregisterConnection",
                value: function value(e, t) {
                  var n = this,
                      r = [];
                  return this.connections.forEach(function (n) {
                    n.source === e && n.destination === t && r.push(n);
                  }), 0 !== r.length && (r.forEach(function (e) {
                    var t = n.connections.indexOf(e);
                    n.connections.splice(t, 1);
                  }), !0);
                }
              }], [{
                key: "outputEdgesFor",
                value: function value(e, t) {
                  var n = [],
                      r = !0,
                      o = !1,
                      i = void 0;

                  try {
                    for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done); r = !0) {
                      var u = a.value;
                      u.source === e && n.push(u);
                    }
                  } catch (e) {
                    o = !0, i = e;
                  } finally {
                    try {
                      !r && s.return && s.return();
                    } finally {
                      if (o) throw i;
                    }
                  }

                  return n;
                }
              }, {
                key: "inputEdgesFor",
                value: function value(e, t) {
                  var n = [],
                      r = !0,
                      o = !1,
                      i = void 0;

                  try {
                    for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done); r = !0) {
                      var u = a.value;
                      u.destination === e && n.push(u);
                    }
                  } catch (e) {
                    o = !0, i = e;
                  } finally {
                    try {
                      !r && s.return && s.return();
                    } finally {
                      if (o) throw i;
                    }
                  }

                  return n;
                }
              }, {
                key: "getInputlessNodes",
                value: function value(e) {
                  var t = [],
                      n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      var s = i.value;
                      t.push(s.source);
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }

                  var u = !0,
                      c = !1,
                      l = void 0;

                  try {
                    for (var f, d = e[Symbol.iterator](); !(u = (f = d.next()).done); u = !0) {
                      var p = f.value,
                          v = t.indexOf(p.destination);
                      -1 !== v && t.splice(v, 1);
                    }
                  } catch (e) {
                    c = !0, l = e;
                  } finally {
                    try {
                      !u && d.return && d.return();
                    } finally {
                      if (c) throw l;
                    }
                  }

                  return t;
                }
              }]), e;
            }();

            t.default = o, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/utils.js":
        /*!**********************!*\
          !*** ./src/utils.js ***!
          \**********************/

        /*! no static exports found */
        function srcUtilsJs(e, t, n) {
          var r, o, i;
          o = [t, n(
          /*! ./Definitions/definitions.js */
          "./src/Definitions/definitions.js"), n(
          /*! ./SourceNodes/sourcenode.js */
          "./src/SourceNodes/sourcenode.js"), n(
          /*! ./SourceNodes/videonode.js */
          "./src/SourceNodes/videonode.js"), n(
          /*! ./SourceNodes/canvasnode.js */
          "./src/SourceNodes/canvasnode.js"), n(
          /*! ./SourceNodes/imagenode.js */
          "./src/SourceNodes/imagenode.js"), n(
          /*! ./DestinationNode/destinationnode.js */
          "./src/DestinationNode/destinationnode.js"), n(
          /*! ./ProcessingNodes/transitionnode.js */
          "./src/ProcessingNodes/transitionnode.js"), n(
          /*! ./ProcessingNodes/compositingnode.js */
          "./src/ProcessingNodes/compositingnode.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r26, o, i, a, s, u) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.UpdateablesManager = void 0, e.compileShader = function (e, t, n) {
              var r = e.createShader(n);
              if (e.shaderSource(r, t), e.compileShader(r), !e.getShaderParameter(r, e.COMPILE_STATUS)) throw "could not compile shader:" + e.getShaderInfoLog(r);
              return r;
            }, e.createShaderProgram = function (e, t, n) {
              var r = e.createProgram();
              if (e.attachShader(r, t), e.attachShader(r, n), e.linkProgram(r), !e.getProgramParameter(r, e.LINK_STATUS)) throw {
                error: 4,
                msg: "Can't link shader program for track",
                toString: function toString() {
                  return this.msg;
                }
              };
              return r;
            }, e.createElementTexture = function (e) {
              var t = e.createTexture();
              return e.bindTexture(e.TEXTURE_2D, t), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !0), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), t;
            }, e.updateTexture = function (e, t, n) {
              void 0 !== n.readyState && 0 === n.readyState || (e.bindTexture(e.TEXTURE_2D, t), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !0), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, n), t._isTextureCleared = !1);
            }, e.clearTexture = function (e, t) {
              t._isTextureCleared || (e.bindTexture(e.TEXTURE_2D, t), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !0), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0])), t._isTextureCleared = !0);
            }, e.generateRandomId = function () {
              function e(e) {
                return e[Math.floor(Math.random() * e.length)];
              }

              var t,
                  n = e(["adorable", "alert", "average", "beautiful", "blonde", "bloody", "blushing", "bright", "clean", "clear", "cloudy", "colourful", "concerned", "crowded", "curious", "cute", "dark", "dirty", "drab", "distinct", "dull", "elegant", "fancy", "filthy", "glamorous", "gleaming", "graceful", "grotesque", "homely", "light", "misty", "motionless", "muddy", "plain", "poised", "quaint", "scary", "shiny", "smoggy", "sparkling", "spotless", "stormy", "strange", "ugly", "unsightly", "unusual"]) + " " + e(["alive", "brainy", "broken", "busy", "careful", "cautious", "clever", "crazy", "damaged", "dead", "difficult", "easy", "fake", "false", "famous", "forward", "fragile", "guilty", "helpful", "helpless", "important", "impossible", "infamous", "innocent", "inquisitive", "mad", "modern", "open", "outgoing", "outstanding", "poor", "powerful", "puzzled", "real", "rich", "right", "robust", "sane", "scary", "shy", "sleepy", "stupid", "super", "tame", "thick", "tired", "wild", "wrong"]) + " " + e(["manatee", "gila monster", "nematode", "seahorse", "slug", "koala bear", "giant tortoise", "garden snail", "starfish", "sloth", "american woodcock", "coral", "swallowtail butterfly", "house sparrow", "sea anemone"]);
              return n = (t = n, n = t = t.replace(/\b\w/g, function (e) {
                return e.toUpperCase();
              })).replace(/ /g, "-");
            }, e.exportToJSON = function (e) {
              return console.warn("VideoContext.exportToJSON has been deprecated. Please use VideoContext.snapshot instead."), JSON.stringify(v(e));
            }, e.snapshot = function (e) {
              return {
                nodes: v(e),
                videoContext: d(e)
              };
            }, e.createControlFormForNode = function (e, t) {
              var n = document.createElement("div");

              if (void 0 !== t) {
                var r = document.createElement("h2");
                r.innerHTML = t, n.appendChild(r);
              }

              var o = function o(t) {
                var r = document.createElement("p"),
                    o = document.createElement("h3");
                o.innerHTML = t, r.appendChild(o);
                var i = e._properties[t].value;

                if ("number" == typeof i) {
                  var s = document.createElement("input");
                  s.setAttribute("type", "range"), s.setAttribute("min", "0"), s.setAttribute("max", "1"), s.setAttribute("step", "0.01"), s.setAttribute("value", i, toString());
                  var u = document.createElement("input");
                  u.setAttribute("type", "number"), u.setAttribute("min", "0"), u.setAttribute("max", "1"), u.setAttribute("step", "0.01"), u.setAttribute("value", i, toString());
                  var c = !1;
                  s.onmousedown = function () {
                    c = !0;
                  }, s.onmouseup = function () {
                    c = !1;
                  }, s.onmousemove = function () {
                    c && (e[t] = parseFloat(s.value), u.value = s.value);
                  }, s.onchange = function () {
                    e[t] = parseFloat(s.value), u.value = s.value;
                  }, u.onchange = function () {
                    e[t] = parseFloat(u.value), s.value = u.value;
                  }, r.appendChild(s), r.appendChild(u);
                } else if ("[object Array]" === Object.prototype.toString.call(i)) {
                  var l = function l() {
                    var n = document.createElement("input");
                    n.setAttribute("type", "range"), n.setAttribute("min", "0"), n.setAttribute("max", "1"), n.setAttribute("step", "0.01"), n.setAttribute("value", i[a], toString());
                    var o = document.createElement("input");
                    o.setAttribute("type", "number"), o.setAttribute("min", "0"), o.setAttribute("max", "1"), o.setAttribute("step", "0.01"), o.setAttribute("value", i, toString());
                    var s = a,
                        u = !1;
                    n.onmousedown = function () {
                      u = !0;
                    }, n.onmouseup = function () {
                      u = !1;
                    }, n.onmousemove = function () {
                      u && (e[t][s] = parseFloat(n.value), o.value = n.value);
                    }, n.onchange = function () {
                      e[t][s] = parseFloat(n.value), o.value = n.value;
                    }, o.onchange = function () {
                      e[t][s] = parseFloat(o.value), n.value = o.value;
                    }, r.appendChild(n), r.appendChild(o);
                  };

                  for (a = 0; a < i.length; a++) {
                    l();
                  }
                }

                n.appendChild(r);
              };

              for (var i in e._properties) {
                var a;
                o(i);
              }

              return n;
            }, e.visualiseVideoContextGraph = function (e, t) {
              var n = t.getContext("2d"),
                  s = t.width,
                  c = t.height;
              n.clearRect(0, 0, s, c);

              var l = function (e) {
                var t = e.destination,
                    n = new Map();
                return n.set(t, 0), function e(t) {
                  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      o = !0,
                      i = !1,
                      a = void 0;

                  try {
                    for (var s, u = t.inputs[Symbol.iterator](); !(o = (s = u.next()).done); o = !0) {
                      var c = s.value,
                          l = r + 1;
                      n.has(c) ? l > n.get(c) && n.set(c, l) : n.set(c, l), e(c, n.get(c));
                    }
                  } catch (e) {
                    i = !0, a = e;
                  } finally {
                    try {
                      !o && u.return && u.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                }(t), n;
              }(e),
                  f = l.values(),
                  d = (f = Array.from(f).sort(function (e, t) {
                return t - e;
              }))[0],
                  p = s / (d + 1),
                  v = c / e._sourceNodes.length / 3,
                  _ = 1.618 * v;

              function h(e, t, n, r) {
                var o = t.get(e);
                t.values();
                var i = 0,
                    a = !0,
                    s = !1,
                    u = void 0;

                try {
                  for (var c, l = t[Symbol.iterator](); !(a = (c = l.next()).done); a = !0) {
                    var f = c.value;
                    if (f[0] === e) break;
                    f[1] === o && (i += 1);
                  }
                } catch (e) {
                  s = !0, u = e;
                } finally {
                  try {
                    !a && l.return && l.return();
                  } finally {
                    if (s) throw u;
                  }
                }

                return {
                  x: n * t.get(e),
                  y: 1.5 * r * i + 50
                };
              }

              for (var m = 0; m < e._renderGraph.connections.length; m++) {
                var y = e._renderGraph.connections[m],
                    g = h(y.source, l, p, v),
                    b = h(y.destination, l, p, v);

                if (void 0 !== g && void 0 !== b) {
                  n.beginPath();
                  var x = g.x + _ / 2,
                      T = g.y + v / 2,
                      E = b.x + _ / 2,
                      C = b.y + v / 2,
                      O = E - x,
                      w = C - T,
                      S = Math.PI / 2 - Math.atan2(O, w),
                      A = Math.sqrt(Math.pow(x - E, 2) + Math.pow(T - C, 2)),
                      k = Math.min(x, E) + (Math.max(x, E) - Math.min(x, E)) / 2,
                      P = Math.min(T, C) + (Math.max(T, C) - Math.min(T, C)) / 2,
                      N = Math.cos(S + Math.PI / 2) * A / 1.5 + k,
                      D = Math.sin(S + Math.PI / 2) * A / 1.5 + P;
                  n.arc(N, D, A / 1.2, S - Math.PI + .95, S - .95), n.stroke();
                }
              }

              var j = !0,
                  R = !1,
                  F = void 0;

              try {
                for (var M, I = l.keys()[Symbol.iterator](); !(j = (M = I.next()).done); j = !0) {
                  var U = M.value,
                      L = h(U, l, p, v),
                      z = "#AA9639",
                      W = "";
                  U.displayName === u.COMPOSITINGTYPE && (z = "#000000"), U.displayName === a.DESTINATIONTYPE && (z = "#7D9F35", W = "Output"), U.displayName === _r26.VIDEOTYPE && (z = "#572A72", W = "Video"), U.displayName === o.CANVASTYPE && (z = "#572A72", W = "Canvas"), U.displayName === i.IMAGETYPE && (z = "#572A72", W = "Image"), n.beginPath(), n.fillStyle = z, n.fillRect(L.x, L.y, _, v), n.fill(), n.fillStyle = "#000", n.textAlign = "center", n.font = "10px Arial", n.fillText(W, L.x + _ / 2, L.y + v / 2 + 2.5), n.fill();
                }
              } catch (e) {
                R = !0, F = e;
              } finally {
                try {
                  !j && I.return && I.return();
                } finally {
                  if (R) throw F;
                }
              }
            }, e.createSigmaGraphDataFromRenderGraph = function (e) {
              function t(t) {
                return -1 !== e._sourceNodes.indexOf(t) ? "source " + t.displayName + " " + e._sourceNodes.indexOf(t) : "processor " + t.displayName + " " + e._processingNodes.indexOf(t);
              }

              for (var n = {
                nodes: [{
                  id: t(e.destination),
                  label: "Destination Node",
                  x: 2.5,
                  y: .5,
                  size: 2,
                  node: e.destination
                }],
                edges: []
              }, r = 0; r < e._sourceNodes.length; r++) {
                var o = e._sourceNodes[r],
                    i = r * (1 / e._sourceNodes.length);
                n.nodes.push({
                  id: t(o),
                  label: "Source " + r.toString(),
                  x: 0,
                  y: i,
                  size: 2,
                  color: "#572A72",
                  node: o
                });
              }

              for (var a = 0; a < e._processingNodes.length; a++) {
                var s = e._processingNodes[a];
                n.nodes.push({
                  id: t(s),
                  x: 2.5 * Math.random(),
                  y: Math.random(),
                  size: 2,
                  node: s
                });
              }

              for (var u = 0; u < e._renderGraph.connections.length; u++) {
                var c = e._renderGraph.connections[u];
                n.edges.push({
                  id: "e" + u.toString(),
                  source: t(c.source),
                  target: t(c.destination)
                });
              }

              return n;
            }, e.importSimpleEDL = function (e, t) {
              var n = e.compositor(l.default.COMBINE),
                  r = !0,
                  o = !1,
                  i = void 0;

              try {
                for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done); r = !0) {
                  var u = a.value,
                      c = void 0;
                  if ("video" === u.type) c = e.video(u.src, u.sourceStart);else {
                    if ("image" !== u.type) {
                      console.debug("Clip type " + u.type + " not recognised, skipping.");
                      continue;
                    }

                    c = e.image(u.src, u.sourceStart);
                  }
                  c.startAt(u.start), c.stopAt(u.start + u.duration), c.connect(n);
                }
              } catch (e) {
                o = !0, i = e;
              } finally {
                try {
                  !r && s.return && s.return();
                } finally {
                  if (o) throw i;
                }
              }

              return n;
            }, e.visualiseVideoContextTimeline = function (e, t, n) {
              var r = t.getContext("2d"),
                  o = t.width,
                  i = t.height,
                  a = i / e._sourceNodes.length,
                  u = e.duration;

              if (n > u && !e.endOnLastSourceEnd && (u = n), e.duration === 1 / 0) {
                for (var c = 0, l = 0; l < e._sourceNodes.length; l++) {
                  var f = e._sourceNodes[l];
                  f._stopTime !== 1 / 0 && (c += f._stopTime);
                }

                u = c > e.currentTime ? c + 5 : e.currentTime + 5;
              }

              var d = o / u,
                  p = {
                video: ["#572A72", "#3C1255"],
                image: ["#7D9F35", "#577714"],
                canvas: ["#AA9639", "#806D15"]
              };
              r.clearRect(0, 0, o, i), r.fillStyle = "#999";

              var v = !0,
                  _ = !1,
                  h = void 0;

              try {
                for (var m, y = e._processingNodes[Symbol.iterator](); !(v = (m = y.next()).done); v = !0) {
                  var g = m.value;
                  if (g.displayName === s.TRANSITIONTYPE) for (var b in g._transitions) {
                    var x = !0,
                        T = !1,
                        E = void 0;

                    try {
                      for (var C, O = g._transitions[b][Symbol.iterator](); !(x = (C = O.next()).done); x = !0) {
                        var w = C.value,
                            S = (w.end - w.start) * d,
                            A = i,
                            k = w.start * d;
                        r.fillStyle = "rgba(0,0,0, 0.3)", r.fillRect(k, 0, S, A), r.fill();
                      }
                    } catch (e) {
                      T = !0, E = e;
                    } finally {
                      try {
                        !x && O.return && O.return();
                      } finally {
                        if (T) throw E;
                      }
                    }
                  }
                }
              } catch (e) {
                _ = !0, h = e;
              } finally {
                try {
                  !v && y.return && y.return();
                } finally {
                  if (_) throw h;
                }
              }

              for (var P = 0; P < e._sourceNodes.length; P++) {
                var N = e._sourceNodes[P],
                    D = N._stopTime - N._startTime;
                D === 1 / 0 && (D = e.currentTime);
                var j = N._startTime,
                    R = D * d,
                    F = a,
                    M = j * d,
                    I = a * P;
                r.fillStyle = p.video[P % p.video.length], r.fillRect(M, I, R, F), r.fill();
              }

              void 0 !== n && (r.fillStyle = "#000", r.fillRect(n * d, 0, 1, i));
            }, e.mediaElementHasSource = function (e) {
              var t = e.src,
                  n = e.srcObject;
              return !(("" === t || void 0 === t) && null == n);
            };

            var c,
                l = (c = t) && c.__esModule ? c : {
              default: c
            },
                f = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }();

            function d(e) {
              return {
                currentTime: e.currentTime,
                duration: e.duration,
                state: e.state,
                playbackRate: e.playbackRate
              };
            }

            var p = !1;

            function v(e) {
              function t(e, t) {
                var n = [],
                    r = !0,
                    o = !1,
                    i = void 0;

                try {
                  for (var a, s = e.inputs[Symbol.iterator](); !(r = (a = s.next()).done); r = !0) {
                    var u = a.value;

                    if (void 0 !== u) {
                      var c = void 0,
                          l = e.inputs.indexOf(u),
                          f = t._processingNodes.indexOf(u);

                      if (f > -1) c = "processor" + f;else {
                        var d = t._sourceNodes.indexOf(u);

                        d > -1 ? c = "source" + d : console.log("Warning, can't find input", u);
                      }
                      n.push({
                        id: c,
                        index: l
                      });
                    }
                  }
                } catch (e) {
                  o = !0, i = e;
                } finally {
                  try {
                    !r && s.return && s.return();
                  } finally {
                    if (o) throw i;
                  }
                }

                return n;
              }

              var o,
                  i,
                  a = {},
                  u = [];

              for (var c in n.SOURCENODESTATE) {
                u[n.SOURCENODESTATE[c]] = c;
              }

              for (var l in e._sourceNodes) {
                var f = e._sourceNodes[l],
                    d = "source" + l,
                    v = "";
                f._isResponsibleForElementLifeCycle ? (o = f._elementURL, i = void 0, (i = document.createElement("a")).href = o, v = i.href) : (p || (console.debug("Warning - Trying to export source created from an element not a URL. URL of export will be set to the elements src attribute and may be incorrect", f), p = !0), v = f.element.src);
                var _ = {
                  type: f.displayName,
                  url: v,
                  start: f.startTime,
                  stop: f.stopTime,
                  state: u[f.state]
                };
                _.type === _r26.VIDEOTYPE && (_.currentTime = null, f.element && f.element.currentTime && (_.currentTime = f.element.currentTime)), f._sourceOffset && (_.sourceOffset = f._sourceOffset), a[d] = _;
              }

              for (var h in e._processingNodes) {
                var m = e._processingNodes[h],
                    y = "processor" + h,
                    g = {
                  type: m.displayName,
                  definition: m._definition,
                  inputs: t(m, e),
                  properties: {}
                };

                for (var b in g.definition.properties) {
                  g.properties[b] = m[b];
                }

                g.type === s.TRANSITIONTYPE && (g.transitions = m._transitions), a[y] = g;
              }

              return a.destination = {
                type: "Destination",
                inputs: t(e.destination, e)
              }, a;
            }

            e.UpdateablesManager = function () {
              function e() {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this._updateables = [], this._useWebworker = !1, this._active = !1, this._previousRAFTime = void 0, this._previousWorkerTime = void 0, this._webWorkerString = "            var running = false;            function tick(){                postMessage(Date.now());                if (running){                    setTimeout(tick, 1000/20);                }            }            self.addEventListener('message',function(msg){                var data = msg.data;                if (data === 'start'){                    running = true;                    tick();                }                if (data === 'stop') running = false;            });", this._webWorker = void 0;
              }

              return f(e, [{
                key: "_initWebWorker",
                value: function value() {
                  var e = this;
                  window.URL = window.URL || window.webkitURL;
                  var t = new Blob([this._webWorkerString], {
                    type: "application/javascript"
                  });
                  this._webWorker = new Worker(URL.createObjectURL(t)), this._webWorker.onmessage = function (t) {
                    var n = t.data;

                    e._updateWorkerTime(n);
                  };
                }
              }, {
                key: "_lostVisibility",
                value: function value() {
                  this._previousWorkerTime = Date.now(), this._useWebworker = !0, this._webWorker || this._initWebWorker(), this._webWorker.postMessage("start");
                }
              }, {
                key: "_gainedVisibility",
                value: function value() {
                  this._useWebworker = !1, this._previousRAFTime = void 0, this._webWorker && this._webWorker.postMessage("stop"), requestAnimationFrame(this._updateRAFTime.bind(this));
                }
              }, {
                key: "_init",
                value: function value() {
                  var e = this;

                  if (window.Worker) {
                    if (void 0 === document.hidden) return window.addEventListener("focus", this._gainedVisibility.bind(this)), void window.addEventListener("blur", this._lostVisibility.bind(this));
                    document.addEventListener("visibilitychange", function () {
                      !0 === document.hidden ? e._lostVisibility() : e._gainedVisibility();
                    }, !1), requestAnimationFrame(this._updateRAFTime.bind(this));
                  }
                }
              }, {
                key: "_updateWorkerTime",
                value: function value(e) {
                  var t = (e - this._previousWorkerTime) / 1e3;
                  0 !== t && this._update(t), this._previousWorkerTime = e;
                }
              }, {
                key: "_updateRAFTime",
                value: function value(e) {
                  void 0 === this._previousRAFTime && (this._previousRAFTime = e);
                  var t = (e - this._previousRAFTime) / 1e3;
                  0 !== t && this._update(t), this._previousRAFTime = e, this._useWebworker || requestAnimationFrame(this._updateRAFTime.bind(this));
                }
              }, {
                key: "_update",
                value: function value(e) {
                  for (var t = 0; t < this._updateables.length; t++) {
                    this._updateables[t]._update(parseFloat(e));
                  }
                }
              }, {
                key: "register",
                value: function value(e) {
                  this._updateables.push(e), !1 === this._active && (this._active = !0, this._init());
                }
              }]), e;
            }();
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/videocontext.js":
        /*!*****************************!*\
          !*** ./src/videocontext.js ***!
          \*****************************/

        /*! no static exports found */
        function srcVideocontextJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./utils.js */
          "./src/utils.js"), n(
          /*! ./SourceNodes/nodes.js */
          "./src/SourceNodes/nodes.js"), n(
          /*! ./SourceNodes/videonode.js */
          "./src/SourceNodes/videonode.js"), n(
          /*! ./SourceNodes/audionode.js */
          "./src/SourceNodes/audionode.js"), n(
          /*! ./SourceNodes/imagenode.js */
          "./src/SourceNodes/imagenode.js"), n(
          /*! ./SourceNodes/canvasnode.js */
          "./src/SourceNodes/canvasnode.js"), n(
          /*! ./SourceNodes/sourcenode.js */
          "./src/SourceNodes/sourcenode.js"), n(
          /*! ./ProcessingNodes/compositingnode.js */
          "./src/ProcessingNodes/compositingnode.js"), n(
          /*! ./DestinationNode/destinationnode.js */
          "./src/DestinationNode/destinationnode.js"), n(
          /*! ./ProcessingNodes/effectnode.js */
          "./src/ProcessingNodes/effectnode.js"), n(
          /*! ./ProcessingNodes/transitionnode.js */
          "./src/ProcessingNodes/transitionnode.js"), n(
          /*! ./rendergraph.js */
          "./src/rendergraph.js"), n(
          /*! ./videoelementcache.js */
          "./src/videoelementcache.js"), n(
          /*! ./Definitions/definitions.js */
          "./src/Definitions/definitions.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r27, o, i, a, s, u, c, l, f, d, p, v, _) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var h = A(_r27),
                m = A(o),
                y = A(i),
                g = A(a),
                b = A(s),
                x = A(c),
                T = A(l),
                E = A(f),
                C = A(d),
                O = A(p),
                w = A(v),
                S = A(_);

            function A(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            var k = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                P = new n.UpdateablesManager(),
                N = function () {
              function e(t, r) {
                var o = this,
                    i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    a = i.manualUpdate,
                    s = void 0 !== a && a,
                    u = i.endOnLastSourceEnd,
                    c = void 0 === u || u,
                    l = i.useVideoElementCache,
                    f = void 0 === l || l,
                    d = i.videoElementCacheSize,
                    p = void 0 === d ? 6 : d,
                    v = i.webglContextAttributes,
                    _ = void 0 === v ? {} : v;

                if (function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this._canvas = t, this._endOnLastSourceEnd = c, this._gl = t.getContext("experimental-webgl", Object.assign({
                  preserveDrawingBuffer: !0
                }, _, {
                  alpha: !1
                })), null === this._gl) return console.error("Failed to intialise WebGL."), void (r && r());
                this._useVideoElementCache = f, this._useVideoElementCache && (this._videoElementCache = new w.default(p)), this._canvas.id && ("string" == typeof this._canvas.id || this._canvas.id instanceof String) && (this._id = t.id), void 0 === this._id && (this._id = (0, n.generateRandomId)()), void 0 === window.__VIDEOCONTEXT_REFS__ && (window.__VIDEOCONTEXT_REFS__ = {}), window.__VIDEOCONTEXT_REFS__[this._id] = this, this._renderGraph = new O.default(), this._sourceNodes = [], this._processingNodes = [], this._timeline = [], this._currentTime = 0, this._state = e.STATE.PAUSED, this._playbackRate = 1, this._volume = 1, this._sourcesPlaying = void 0, this._destinationNode = new T.default(this._gl, this._renderGraph), this._callbacks = new Map(), Object.keys(e.EVENTS).forEach(function (t) {
                  return o._callbacks.set(e.EVENTS[t], []);
                }), this._timelineCallbacks = [], s || P.register(this);
              }

              return k(e, [{
                key: "registerTimelineCallback",
                value: function value(e, t) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;

                  this._timelineCallbacks.push({
                    time: e,
                    func: t,
                    ordering: n
                  });
                }
              }, {
                key: "unregisterTimelineCallback",
                value: function value(e) {
                  var t = [],
                      n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = this._timelineCallbacks[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      var s = i.value;
                      s.func === e && t.push(s);
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }

                  var u = !0,
                      c = !1,
                      l = void 0;

                  try {
                    for (var f, d = t[Symbol.iterator](); !(u = (f = d.next()).done); u = !0) {
                      var p = f.value,
                          v = this._timelineCallbacks.indexOf(p);

                      this._timelineCallbacks.splice(v, 1);
                    }
                  } catch (e) {
                    c = !0, l = e;
                  } finally {
                    try {
                      !u && d.return && d.return();
                    } finally {
                      if (c) throw l;
                    }
                  }
                }
              }, {
                key: "registerCallback",
                value: function value(e, t) {
                  if (!this._callbacks.has(e)) return !1;

                  this._callbacks.get(e).push(t);
                }
              }, {
                key: "unregisterCallback",
                value: function value(e) {
                  var t = !0,
                      n = !1,
                      r = void 0;

                  try {
                    for (var o, i = this._callbacks.values()[Symbol.iterator](); !(t = (o = i.next()).done); t = !0) {
                      var a = o.value,
                          s = a.indexOf(e);
                      if (-1 !== s) return a.splice(s, 1), !0;
                    }
                  } catch (e) {
                    n = !0, r = e;
                  } finally {
                    try {
                      !t && i.return && i.return();
                    } finally {
                      if (n) throw r;
                    }
                  }

                  return !1;
                }
              }, {
                key: "_callCallbacks",
                value: function value(e) {
                  var t = this._callbacks.get(e),
                      n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = t[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      (0, i.value)(this._currentTime);
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }
                }
              }, {
                key: "play",
                value: function value() {
                  return console.debug("VideoContext - playing"), this._videoElementCache && this._videoElementCache.init(), this._state = e.STATE.PLAYING, !0;
                }
              }, {
                key: "pause",
                value: function value() {
                  return console.debug("VideoContext - pausing"), this._state = e.STATE.PAUSED, !0;
                }
              }, {
                key: "video",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4,
                      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                      o = new m.default(e, this._gl, this._renderGraph, this._currentTime, this._playbackRate, t, n, this._videoElementCache, r);
                  return this._sourceNodes.push(o), o;
                }
              }, {
                key: "audio",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4,
                      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                      o = new y.default(e, this._gl, this._renderGraph, this._currentTime, this._playbackRate, t, n, this._audioElementCache, r);
                  return this._sourceNodes.push(o), o;
                }
              }, {
                key: "createVideoSourceNode",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4,
                      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
                  return this._deprecate("Warning: createVideoSourceNode will be deprecated in v1.0, please switch to using VideoContext.video()"), this.video(e, t, n, r);
                }
              }, {
                key: "image",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 4,
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                      r = new g.default(e, this._gl, this._renderGraph, this._currentTime, t, n);
                  return this._sourceNodes.push(r), r;
                }
              }, {
                key: "createImageSourceNode",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4,
                      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
                  return this._deprecate("Warning: createImageSourceNode will be deprecated in v1.0, please switch to using VideoContext.image()"), this.image(e, t, n, r);
                }
              }, {
                key: "canvas",
                value: function value(e) {
                  var t = new b.default(e, this._gl, this._renderGraph, this._currentTime);
                  return this._sourceNodes.push(t), t;
                }
              }, {
                key: "createCanvasSourceNode",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4;
                  return this._deprecate("Warning: createCanvasSourceNode will be deprecated in v1.0, please switch to using VideoContext.canvas()"), this.canvas(e, t, n);
                }
              }, {
                key: "effect",
                value: function value(e) {
                  var t = new E.default(this._gl, this._renderGraph, e);
                  return this._processingNodes.push(t), t;
                }
              }, {
                key: "createEffectNode",
                value: function value(e) {
                  return this._deprecate("Warning: createEffectNode will be deprecated in v1.0, please switch to using VideoContext.effect()"), this.effect(e);
                }
              }, {
                key: "compositor",
                value: function value(e) {
                  var t = new x.default(this._gl, this._renderGraph, e);
                  return this._processingNodes.push(t), t;
                }
              }, {
                key: "customSourceNode",
                value: function value(e, t) {
                  for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
                    r[o - 2] = arguments[o];
                  }

                  var i = new (Function.prototype.bind.apply(e, [null].concat([t, this._gl, this._renderGraph, this._currentTime], r)))();
                  return this._sourceNodes.push(i), i;
                }
              }, {
                key: "createCompositingNode",
                value: function value(e) {
                  return this._deprecate("Warning: createCompositingNode will be deprecated in v1.0, please switch to using VideoContext.compositor()"), this.compositor(e);
                }
              }, {
                key: "transition",
                value: function value(e) {
                  var t = new C.default(this._gl, this._renderGraph, e);
                  return this._processingNodes.push(t), t;
                }
              }, {
                key: "createTransitionNode",
                value: function value(e) {
                  return this._deprecate("Warning: createTransitionNode will be deprecated in v1.0, please switch to using VideoContext.transition()"), this.transition(e);
                }
              }, {
                key: "_isStalled",
                value: function value() {
                  for (var e = 0; e < this._sourceNodes.length; e++) {
                    if (!this._sourceNodes[e]._isReady()) return !0;
                  }

                  return !1;
                }
              }, {
                key: "update",
                value: function value(e) {
                  this._update(e);
                }
              }, {
                key: "_update",
                value: function value(t) {
                  if (this._sourceNodes = this._sourceNodes.filter(function (e) {
                    if (!e.destroyed) return e;
                  }), this._processingNodes = this._processingNodes.filter(function (e) {
                    if (!e.destroyed) return e;
                  }), this._state === e.STATE.PLAYING || this._state === e.STATE.STALLED || this._state === e.STATE.PAUSED) {
                    if (this._callCallbacks(e.EVENTS.UPDATE), this._state !== e.STATE.PAUSED && (this._isStalled() ? (this._callCallbacks(e.EVENTS.STALLED), this._state = e.STATE.STALLED) : this._state = e.STATE.PLAYING), this._state === e.STATE.PLAYING) {
                      var n = new Map(),
                          r = !0,
                          o = !1,
                          i = void 0;

                      try {
                        for (var a, s = this._timelineCallbacks[Symbol.iterator](); !(r = (a = s.next()).done); r = !0) {
                          var c = a.value;
                          c.time >= this.currentTime && c.time < this._currentTime + t * this._playbackRate && (n.has(c.time) || n.set(c.time, []), n.get(c.time).push(c));
                        }
                      } catch (e) {
                        o = !0, i = e;
                      } finally {
                        try {
                          !r && s.return && s.return();
                        } finally {
                          if (o) throw i;
                        }
                      }

                      var l = Array.from(n.keys());
                      l.sort(function (e, t) {
                        return e - t;
                      });
                      var f = !0,
                          d = !1,
                          p = void 0;

                      try {
                        for (var v, _ = l[Symbol.iterator](); !(f = (v = _.next()).done); f = !0) {
                          var h = v.value,
                              m = n.get(h);
                          m.sort(function (e, t) {
                            return e.ordering - t.ordering;
                          });
                          var y = !0,
                              g = !1,
                              b = void 0;

                          try {
                            for (var x, T = m[Symbol.iterator](); !(y = (x = T.next()).done); y = !0) {
                              x.value.func();
                            }
                          } catch (e) {
                            g = !0, b = e;
                          } finally {
                            try {
                              !y && T.return && T.return();
                            } finally {
                              if (g) throw b;
                            }
                          }
                        }
                      } catch (e) {
                        d = !0, p = e;
                      } finally {
                        try {
                          !f && _.return && _.return();
                        } finally {
                          if (d) throw p;
                        }
                      }

                      if (this._currentTime += t * this._playbackRate, this._currentTime > this.duration && this._endOnLastSourceEnd) {
                        for (var E = 0; E < this._sourceNodes.length; E++) {
                          this._sourceNodes[E]._update(this._currentTime);
                        }

                        this._state = e.STATE.ENDED, this._callCallbacks(e.EVENTS.ENDED);
                      }
                    }

                    for (var C = !1, w = 0; w < this._sourceNodes.length; w++) {
                      var S = this._sourceNodes[w];
                      this._state === e.STATE.STALLED && S._isReady() && S._state === u.SOURCENODESTATE.playing && S._pause(), this._state === e.STATE.PAUSED && S._pause(), this._state === e.STATE.PLAYING && S._play(), S._update(this._currentTime), S._state !== u.SOURCENODESTATE.paused && S._state !== u.SOURCENODESTATE.playing || (C = !0);
                    }

                    C !== this._sourcesPlaying && this._state === e.STATE.PLAYING && (!0 === C ? this._callCallbacks(e.EVENTS.CONTENT) : this._callCallbacks(e.EVENTS.NOCONTENT), this._sourcesPlaying = C);

                    for (var A = [], k = this._renderGraph.connections.slice(), P = O.default.getInputlessNodes(k); P.length > 0;) {
                      var N = P.pop();
                      A.push(N);
                      var D = !0,
                          j = !1,
                          R = void 0;

                      try {
                        for (var F, M = O.default.outputEdgesFor(N, k)[Symbol.iterator](); !(D = (F = M.next()).done); D = !0) {
                          var I = F.value,
                              U = k.indexOf(I);
                          U > -1 && k.splice(U, 1), 0 === O.default.inputEdgesFor(I.destination, k).length && P.push(I.destination);
                        }
                      } catch (e) {
                        j = !0, R = e;
                      } finally {
                        try {
                          !D && M.return && M.return();
                        } finally {
                          if (j) throw R;
                        }
                      }
                    }

                    var L = !0,
                        z = !1,
                        W = void 0;

                    try {
                      for (var B, V = A[Symbol.iterator](); !(L = (B = V.next()).done); L = !0) {
                        var G = B.value;
                        -1 === this._sourceNodes.indexOf(G) && (G._update(this._currentTime), G._render());
                      }
                    } catch (e) {
                      z = !0, W = e;
                    } finally {
                      try {
                        !L && V.return && V.return();
                      } finally {
                        if (z) throw W;
                      }
                    }
                  }
                }
              }, {
                key: "reset",
                value: function value() {
                  var t = this,
                      n = !0,
                      r = !1,
                      o = void 0;

                  try {
                    for (var i, a = this._callbacks[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                      var s = i.value;
                      this.unregisterCallback(s);
                    }
                  } catch (e) {
                    r = !0, o = e;
                  } finally {
                    try {
                      !n && a.return && a.return();
                    } finally {
                      if (r) throw o;
                    }
                  }

                  var u = !0,
                      c = !1,
                      l = void 0;

                  try {
                    for (var f, d = this._sourceNodes[Symbol.iterator](); !(u = (f = d.next()).done); u = !0) {
                      f.value.destroy();
                    }
                  } catch (e) {
                    c = !0, l = e;
                  } finally {
                    try {
                      !u && d.return && d.return();
                    } finally {
                      if (c) throw l;
                    }
                  }

                  var p = !0,
                      v = !1,
                      _ = void 0;

                  try {
                    for (var h, m = this._processingNodes[Symbol.iterator](); !(p = (h = m.next()).done); p = !0) {
                      h.value.destroy();
                    }
                  } catch (e) {
                    v = !0, _ = e;
                  } finally {
                    try {
                      !p && m.return && m.return();
                    } finally {
                      if (v) throw _;
                    }
                  }

                  this._update(0), this._sourceNodes = [], this._processingNodes = [], this._timeline = [], this._currentTime = 0, this._state = e.STATE.PAUSED, this._playbackRate = 1, this._sourcesPlaying = void 0, Object.keys(e.EVENTS).forEach(function (n) {
                    return t._callbacks.set(e.EVENTS[n], []);
                  }), this._timelineCallbacks = [];
                }
              }, {
                key: "_deprecate",
                value: function value(e) {
                  console.log(e);
                }
              }, {
                key: "snapshot",
                value: function value() {
                  return (0, n.snapshot)(this);
                }
              }, {
                key: "id",
                get: function get() {
                  return this._id;
                },
                set: function set(e) {
                  delete window.__VIDEOCONTEXT_REFS__[this._id], void 0 !== window.__VIDEOCONTEXT_REFS__[e] && console.warn("Warning; setting id to that of an existing VideoContext instance."), window.__VIDEOCONTEXT_REFS__[e] = this, this._id = e;
                }
              }, {
                key: "element",
                get: function get() {
                  return this._canvas;
                }
              }, {
                key: "state",
                get: function get() {
                  return this._state;
                }
              }, {
                key: "currentTime",
                set: function set(t) {
                  t < this.duration && this._state === e.STATE.ENDED && (this._state = e.STATE.PAUSED), ("string" == typeof t || t instanceof String) && (t = parseFloat(t));

                  for (var n = 0; n < this._sourceNodes.length; n++) {
                    this._sourceNodes[n]._seek(t);
                  }

                  for (var r = 0; r < this._processingNodes.length; r++) {
                    this._processingNodes[r]._seek(t);
                  }

                  this._currentTime = t;
                },
                get: function get() {
                  return this._currentTime;
                }
              }, {
                key: "duration",
                get: function get() {
                  for (var e = 0, t = 0; t < this._sourceNodes.length; t++) {
                    this._sourceNodes[t].state !== u.SOURCENODESTATE.waiting && this._sourceNodes[t]._stopTime > e && (e = this._sourceNodes[t]._stopTime);
                  }

                  return e;
                }
              }, {
                key: "destination",
                get: function get() {
                  return this._destinationNode;
                }
              }, {
                key: "playbackRate",
                set: function set(e) {
                  if (e <= 0) throw new RangeError("playbackRate must be greater than 0");
                  var t = !0,
                      n = !1,
                      r = void 0;

                  try {
                    for (var i, a = this._sourceNodes[Symbol.iterator](); !(t = (i = a.next()).done); t = !0) {
                      var s = i.value;
                      s.constructor.name === o.VIDEOTYPE && (s._globalPlaybackRate = e, s._playbackRateUpdated = !0);
                    }
                  } catch (e) {
                    n = !0, r = e;
                  } finally {
                    try {
                      !t && a.return && a.return();
                    } finally {
                      if (n) throw r;
                    }
                  }

                  this._playbackRate = e;
                },
                get: function get() {
                  return this._playbackRate;
                }
              }, {
                key: "volume",
                set: function set(e) {
                  var t = !0,
                      n = !1,
                      r = void 0;

                  try {
                    for (var o, i = this._sourceNodes[Symbol.iterator](); !(t = (o = i.next()).done); t = !0) {
                      var a = o.value;
                      (a instanceof m.default || a instanceof y.default) && (a.volume = e);
                    }
                  } catch (e) {
                    n = !0, r = e;
                  } finally {
                    try {
                      !t && i.return && i.return();
                    } finally {
                      if (n) throw r;
                    }
                  }

                  this._volume = e;
                },
                get: function get() {
                  return this._volume;
                }
              }], [{
                key: "DEFINITIONS",
                get: function get() {
                  return S.default;
                }
              }, {
                key: "NODES",
                get: function get() {
                  return h.default;
                }
              }]), e;
            }();

            t.default = N;
            var D = Object.freeze({
              PLAYING: 0,
              PAUSED: 1,
              STALLED: 2,
              ENDED: 3,
              BROKEN: 4
            });
            N.STATE = D;
            var j = Object.freeze({
              UPDATE: "update",
              STALLED: "stalled",
              ENDED: "ended",
              CONTENT: "content",
              NOCONTENT: "nocontent"
            });
            N.EVENTS = j, N.visualiseVideoContextTimeline = n.visualiseVideoContextTimeline, N.visualiseVideoContextGraph = n.visualiseVideoContextGraph, N.createControlFormForNode = n.createControlFormForNode, N.createSigmaGraphDataFromRenderGraph = n.createSigmaGraphDataFromRenderGraph, N.exportToJSON = n.exportToJSON, N.updateablesManager = P, N.importSimpleEDL = n.importSimpleEDL, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/videoelementcache.js":
        /*!**********************************!*\
          !*** ./src/videoelementcache.js ***!
          \**********************************/

        /*! no static exports found */
        function srcVideoelementcacheJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./videoelementcacheitem */
          "./src/videoelementcacheitem.js"), n(
          /*! ./utils */
          "./src/utils.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n, _r28) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var o,
                i = (o = n) && o.__esModule ? o : {
              default: o
            },
                a = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                s = function () {
              function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 3;
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this._cacheItems = [], this._cacheItemsInitialised = !1;

                for (var n = 0; n < t; n++) {
                  this._cacheItems.push(new i.default());
                }
              }

              return a(e, [{
                key: "init",
                value: function value() {
                  if (!this._cacheItemsInitialised) {
                    var e = function e(_e3) {
                      try {
                        _e3.element.play().then(function () {
                          _e3.isPlaying() || _e3.element.pause();
                        }, function (e) {
                          if ("NotSupportedError" !== e.name) throw e;
                        });
                      } catch (e) {}
                    },
                        t = !0,
                        n = !1,
                        r = void 0;

                    try {
                      for (var o, i = this._cacheItems[Symbol.iterator](); !(t = (o = i.next()).done); t = !0) {
                        e(o.value);
                      }
                    } catch (e) {
                      n = !0, r = e;
                    } finally {
                      try {
                        !t && i.return && i.return();
                      } finally {
                        if (n) throw r;
                      }
                    }
                  }

                  this._cacheItemsInitialised = !0;
                }
              }, {
                key: "getElementAndLinkToNode",
                value: function value(e) {
                  var t = !0,
                      n = !1,
                      o = void 0;

                  try {
                    for (var a, s = this._cacheItems[Symbol.iterator](); !(t = (a = s.next()).done); t = !0) {
                      var u = a.value;
                      if (!(0, _r28.mediaElementHasSource)(u.element)) return u.linkNode(e), u.element;
                    }
                  } catch (e) {
                    n = !0, o = e;
                  } finally {
                    try {
                      !t && s.return && s.return();
                    } finally {
                      if (n) throw o;
                    }
                  }

                  console.debug("No available video element in the cache, creating a new one. This may break mobile, make your initial cache larger.");
                  var c = new i.default(e);
                  return this._cacheItems.push(c), this._cacheItemsInitialised = !1, c.element;
                }
              }, {
                key: "unlinkNodeFromElement",
                value: function value(e) {
                  var t = !0,
                      n = !1,
                      r = void 0;

                  try {
                    for (var o, i = this._cacheItems[Symbol.iterator](); !(t = (o = i.next()).done); t = !0) {
                      var a = o.value;
                      e === a._element && a.unlinkNode();
                    }
                  } catch (e) {
                    n = !0, r = e;
                  } finally {
                    try {
                      !t && i.return && i.return();
                    } finally {
                      if (n) throw r;
                    }
                  }
                }
              }, {
                key: "length",
                get: function get() {
                  return this._cacheItems.length;
                }
              }, {
                key: "unused",
                get: function get() {
                  var e = 0,
                      t = !0,
                      n = !1,
                      o = void 0;

                  try {
                    for (var i, a = this._cacheItems[Symbol.iterator](); !(t = (i = a.next()).done); t = !0) {
                      var s = i.value;
                      (0, _r28.mediaElementHasSource)(s.element) || (e += 1);
                    }
                  } catch (e) {
                    n = !0, o = e;
                  } finally {
                    try {
                      !t && a.return && a.return();
                    } finally {
                      if (n) throw o;
                    }
                  }

                  return e;
                }
              }]), e;
            }();

            t.default = s, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        },
        "./src/videoelementcacheitem.js":
        /*!**************************************!*\
          !*** ./src/videoelementcacheitem.js ***!
          \**************************************/

        /*! no static exports found */
        function srcVideoelementcacheitemJs(e, t, n) {
          var r, o, i;
          o = [e, t, n(
          /*! ./SourceNodes/sourcenode */
          "./src/SourceNodes/sourcenode.js")], void 0 === (i = "function" == typeof (r = function r(e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r = function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
              }

              return function (t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t;
              };
            }(),
                o = function () {
              function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this._element = this._createElement(), this._node = t;
              }

              return r(e, [{
                key: "_createElement",
                value: function value() {
                  var e = document.createElement("video");
                  return e.setAttribute("crossorigin", "anonymous"), e.setAttribute("webkit-playsinline", ""), e.setAttribute("playsinline", ""), e;
                }
              }, {
                key: "linkNode",
                value: function value(e) {
                  this._node = e;
                }
              }, {
                key: "unlinkNode",
                value: function value() {
                  this._node = null;
                }
              }, {
                key: "isPlaying",
                value: function value() {
                  return this._node && this._node._state === n.SOURCENODESTATE.playing;
                }
              }, {
                key: "element",
                get: function get() {
                  return this._element;
                },
                set: function set(e) {
                  this._element = e;
                }
              }]), e;
            }();

            t.default = o, e.exports = t.default;
          }) ? r.apply(t, o) : r) || (e.exports = i);
        }
      });
    }, e.exports = r();
  }
});